import React, { useEffect, useMemo, useRef, useState } from 'react'
import { TextField, Grid, Typography, CircularProgress, Card, Badge, Box, Stack, Icon, FormHelperText, Checkbox, FormControlLabel, FormGroup, FormControl, Accordion, AccordionDetails, AccordionSummary, Switch } from '@mui/material';
import MDButton from 'components/MDButton';
import CommonQuillEditor from 'common/editor';
import { useSelector } from 'react-redux';
import { createStaticPage, deleteLegal, getStaticLegal, openSnackbar, updateStaticPage, uploadImage } from '../../redux/slices/common';
import { useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ReviewValidation } from 'validations/aboutUs';
import { getData } from 'utilities/common';
import { closeCustomModalDialog, openCustomModalDialog } from '../../redux/slices/modalSlice';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { slugRegexwithunderScor } from 'utilities/common';
import DeleteIcon from 'common/customIcons/delete';
import MDInput from 'components/MDInput';
import { zipCodeValidation } from 'validations/aboutUs';

const badgeCircularProgressIcon = {
    backgroundColor: '#fff',
    borderRadius: 10,
    p: .5,
    mr: 14,
    mt: 14
};

const uploadThumbnailImage = {
    borderRadius: '20px',
    width: '160px',
    height: '160px',
    objectFit: 'cover',
    boxShadow: '0 0 1px rgb(0 0 0 / 20%)'
};

const initialState = {
    'heading': '',
    "sectionType": "same_day_delivery",
    "status": true
    , "headerSection": {
        "section": {
            "description": "",
            "image": {
                "url": "",
                "title": "",
                "description": "",
                "alt": ""
            },
          
        },
        "cta": [
            { "name": "", "link": "" },
        ],
        "points": [
            { "name": "", "desc": "" },
        ],
        "status": true,
        "pageTitle": ""
    },
    "dispensaryTrip": {
        "pageTitle": "",
        "status": true,
        "section": [
            {
                "title": "",
                "description": "",
                "image": {
                    "url": "",
                    "title": "",
                    "description": "",
                    "alt": ""
                },
            }
        ],
        "description": ""
    },

    "weedDeliveryWorks": {
        "pageTitle": "",
        "description": "",
        "status": true,
        "section": [
            {
                "title": "",
                "description": "",
                // "imageUrl": ""
                "image": {
                    "url": "",
                    "title": "",
                    "description": "",
                    "alt": ""
                },
            }
        ]
    },
    "sameDayDeliveryTiming": {
        "pageTitle": "",
        "description": "",
        "status": true,
        "section": [
            {
                "title": "",
                "description": "",
                "image": {
                    "url": "",
                    "title": "",
                    "description": "",
                    "alt": ""
                },
            }
        ]
    },

    "deliveryAreas": {
        "status": true,
        "pageTitle": "",
        "description": ""
    },
    "hyperwolfForWeedDelivery": {
        "pageTitle": "",
        "status": true,
        "section": [
            {
                "title": "",
                "description": "",
                "image": {
                    "url": "",
                    "title": "",
                    "description": "",
                    "alt": ""
                },
            }
        ],
    },
    "compliantCannabisDelivery": {
        "pageTitle": "",
        "description": "",
        "status": true,
        "image": {
            "url": "",
            "title": "",
            "description": "",
            "alt": ""
        },
        "section": [
            {
                "title": "",
                "description": "",


            }
        ],
        "content1": "",
        "content2": "",
    },
    "displaySettings": {
        "hamburgerMenu": true,
        "footer": true
    },
    "metaProperties": {
        "title": "",
        "description": "",
    },
    "footerSection": {
        "section": {
            "description": "",
            "image": {
                "url": "",
                "title": "",
                "description": "",
                "alt": ""
            },
          
        },
        "cta": [
            { "name": "", "link": "" },
        ],
      
        "status": true,
        "pageTitle": ""
    },
    'faq': {
        "status": true,
        "section": [
        ]
    },

}

const defaultSingleSection = {
    description: "",
    image: {
        url: "",
        title: "",
        description: "",
        alt: ""
    },
};

const normalizeSingleSection = (section) => {
    if (Array.isArray(section)) {
        return section[0] || { ...defaultSingleSection };
    }
    return section || { ...defaultSingleSection };
};

const normalizeSectionWithObject = (sectionData) => {
    if (!sectionData) return sectionData;
    return {
        ...sectionData,
        section: normalizeSingleSection(sectionData.section),
    };
};

const SameDayDeliveryPageEdit = ({ legalId, dataProps, fullRoleTabSlug }) => {

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { isUploading = false, isLoading = false, isdltLoading = false, singleLegal } = useSelector((state => state.common));
    const [errors, setErrors] = useState({});
    const uploadedImageRef = useRef();
    const user = getData('login-user-info')
    const parseUser = JSON.parse(user)
    const [formData, setFormData] = useState({ ...initialState, createdBy: parseUser?.name });
    const [searchParams, setSearchParams] = useSearchParams();
    const fullRoleTab = useMemo(() => searchParams.get('roleTab'), [searchParams]);
    const fullRoleTabHeading = useMemo(() => searchParams.get('heading'), [searchParams]);
    const pageExist = useMemo(() => searchParams.get('pageExist'), [searchParams]);
    const [islegalSlugData, setIslegalSlugData] = useState(false)
    const [notSlug, setNotSlug] = useState(false)
    console.log("formasss", formData);

    const checkboxGroup = {
        backgroundColor: "#F2F3F7",
        borderRadius: "6px",
        px: 2.5,
        py: 1,
        flexDirection: "row",
        columnGap: 3
    };

    // ************************************************** Submit Handler **************************************************

    const isEmptyObject = (obj) => {
        return obj && Object.keys(obj).length === 0;
    };

    const isBlankError = (errors) => {
        return (

            errors.metaProperties.title === "" && // Check empty string
            errors.metaProperties.description === "" && // Check empty string

            (!errors.displaySettings || isEmptyObject(errors.displaySettings))
        );
    };
    //  get page heading
    useEffect(() => {
        if (!fullRoleTabSlug) {
            setFormData((prev) => ({
                prev,
                ...prev,
                heading: fullRoleTabHeading
            }))
        }
    }, [fullRoleTabHeading])

    const handleSubmit = (e) => {

        e.preventDefault();

        if (!fullRoleTabHeading) {
            showError('Save aborted. Please check your inputs for errors.', 'error');
            return;
        }
        if (pageExist === 'yes') {
            showError('Page Already Exist.', 'error');
            return
        }
        const { errors, isValid } = zipCodeValidation(formData);

        if (!isValid && !isBlankError(errors)) {

            showError('Save aborted. Please check your inputs for errors.', 'error');
            setErrors(errors);
            return;
        }

        setErrors({});

        const updatedValue = {
            ...formData,
            status: dataProps?.status,
            sectionType: "same_day_delivery",
            headerSection: normalizeSectionWithObject(formData.headerSection),
            footerSection: normalizeSectionWithObject(formData.footerSection),
        };
        if (!islegalSlugData) {
            delete updatedValue.slug;
            // delete updatedValue?.metaProperties?.canonical;
        }
        delete updatedValue.legalSlugArray
        if (updatedValue?.metaProperties && typeof updatedValue.metaProperties === 'object') {
            updatedValue.metaProperties = Object.fromEntries(
                Object.entries(updatedValue.metaProperties).filter(([key]) => key !== 'canonical')
            );
        }

        if (fullRoleTabSlug) {
            dispatch(updateStaticPage({ data: updatedValue, id: fullRoleTabHeading, platform: fullRoleTab })).unwrap().then((res) => {
                showError(res?.message, 'success');
                navigate('/manages/static');
            }).catch((err) => {
                showError(err?.message, 'error');
            });
        } else {
            const cleanedFormData = {
                ...formData,
                heading: formData.heading.trimEnd(),
                headerSection: normalizeSectionWithObject(formData.headerSection),
                footerSection: normalizeSectionWithObject(formData.footerSection),
            };

            delete cleanedFormData.prev;
            console.log("cleanedFormData",cleanedFormData);
            
            dispatch(createStaticPage(cleanedFormData)).unwrap().then((res) => {
                showError(res?.message, 'success');
                navigate('/manages/static');
            }).catch((err) => {
                showError(err?.message, 'error');
            });
        }
    }

    const showError = (message, errortype) => {
        if (errortype === 'success') {
            dispatch(openSnackbar({ content: message, color: 'success', icon: 'check' }));
        }
        if (errortype === 'error') {
            dispatch(openSnackbar({ content: message, color: 'error', icon: 'warning' }));
        }
    };

    // ************************************************** TOPIC section **************************************************

    const updateBannerField = (index, key, value, sectionType, fileName = "") => {

        setFormData((prev) => {
            const updatedFormData = { ...prev };

            const updateSection = (sectionKey, sectionArrayKey) => {
                const updatedSections = [...(prev[sectionKey]?.[sectionArrayKey] || [])];

                if (!updatedSections[index]) return;

                if (key === "imageUrl") {
                    updatedSections[index] = {
                        ...updatedSections[index],
                        image: {
                            url: value,
                            title: fileName || updatedSections[index]?.image?.title || "",
                            alt: updatedSections[index]?.image?.alt || "",
                            description: updatedSections[index]?.image?.description || "",
                        },
                    };
                } else {
                    updatedSections[index] = { ...updatedSections[index], [key]: value };
                }

                updatedFormData[sectionKey] = {
                    ...prev[sectionKey],
                    [sectionArrayKey]: updatedSections,
                };
            };

            if (sectionType === "weedDeliveryWorks" && prev.weedDeliveryWorks?.section) {
                updateSection("weedDeliveryWorks", "section");
            } else if (sectionType === "dispensaryTrip" && prev.dispensaryTrip?.section) {
                updateSection("dispensaryTrip", "section");
            } else if (sectionType === "sameDayDeliveryTiming" && prev.sameDayDeliveryTiming?.section) {
                updateSection("sameDayDeliveryTiming", "section");
            } else if (sectionType === "hyperwolfForWeedDelivery" && prev.hyperwolfForWeedDelivery?.section) {
                updateSection("hyperwolfForWeedDelivery", "section");
            } else if (sectionType === "compliantCannabisDelivery" && prev.compliantCannabisDelivery?.section) {
                updateSection("compliantCannabisDelivery", "section");
            }
            return updatedFormData;
        });
    };

    const handleShowOnChange = (field) => {
        setFormData((prev) => ({
            ...prev,
            displaySettings: {
                ...prev.displaySettings,
                [field]: !prev.displaySettings[field],
            },
        }));
    };
console.log("validations/aboutUs",formData);

    // ************************************************** Get Data **************************************************
    useEffect(() => {
        if (fullRoleTabSlug) {
            dispatch(getStaticLegal({ id: fullRoleTabHeading, platform: fullRoleTab })).unwrap().then((res) => {
                setNotSlug(true)
                const legalDetails = res?.legalDetails || {};
                setFormData(prev => ({
                    ...prev,
                    ...legalDetails,
                    heading: fullRoleTabHeading ? fullRoleTabHeading : legalDetails?.heading,
                    headerSection: normalizeSectionWithObject(legalDetails.headerSection) || prev.headerSection,
                    footerSection: normalizeSectionWithObject(legalDetails.footerSection) || prev.footerSection,
                }));
            }).catch((err) => {
                setNotSlug(false)
                setFormData({
                    ...initialState,
                    createdBy: parseUser?.name || "",
                    heading: fullRoleTabHeading ? fullRoleTabHeading : '',
                    platformAvailability: {
                        hyperwolf: fullRoleTab === 'hyperwolf' ? true : false,
                        hemp: fullRoleTab === 'hemp' ? true : false,
                        stilo: fullRoleTab === 'stilo' ? true : false,
                    },
                });
            });
        } else {
            setFormData(prev => ({
                ...initialState,
                createdBy: parseUser?.name,
                heading: fullRoleTabHeading ? fullRoleTabHeading : '',
                platformAvailability: {
                    hyperwolf: fullRoleTab === 'hyperwolf' ? true : false,
                    hemp: fullRoleTab === 'hemp' ? true : false,
                    stilo: fullRoleTab === 'stilo' ? true : false,
                },
            }));

        }
    }, [fullRoleTabSlug, fullRoleTab])

    const [expanded, setExpanded] = React.useState(false);

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    const handleChangeSlug = (e) => {
        const value = e.target.value;
        setIslegalSlugData(true);
        setFormData((prev => ({
            ...prev,
            slug: slugRegexwithunderScor(value)
        })))
    };

    const deleteHandler = (deleteId) => {
        dispatch(deleteLegal({ slug: deleteId, platform: fullRoleTab }))
            .unwrap()
            .then((res) => {
                showError(res?.message, "success");
                dispatch(closeCustomModalDialog());
                navigate('/manages/static');
            })
            .catch((err) => {
                showError(err?.message, "error");
            });
    };
    const handleRemoveFAQ = (faQIdx) => {
        let FAQArray = [...(formData?.faq?.section || [])];
        FAQArray = FAQArray.filter((faq, _idx) => _idx !== faQIdx);
        setFormData({
            ...formData,
            faq: {
                ...formData?.faq,
                section: FAQArray
            }
        });
    };

    const addFAQHandler = () => {
        let newFAQ = [...(formData?.faq?.section || [])];
        let faqItem = {
            question: '',
            answer: ''
        };
        newFAQ.push(faqItem);
        setFormData({
            ...formData,
            faq: {
                ...formData?.faq,
                section: newFAQ
            }
        });
    };

    const handleChangeFAQ = (value, fieldType, idx) => {
        let FAQArray = [...(formData?.faq?.section || [])];
        if (FAQArray[idx]) {
            FAQArray[idx] = {
                ...FAQArray[idx],
                [fieldType]: value
            };
            setFormData({
                ...formData,
                faq: {
                    ...formData?.faq,
                    section: FAQArray
                }
            });
        }
    };

    const handleChangeHeaderCta = (value, fieldType, idx, section = "headerSection") => {
        setFormData((prev) => {
            const ctaArray = [...(prev[section]?.cta || [])];
            if (!ctaArray[idx]) return prev;
            ctaArray[idx] = { ...ctaArray[idx], [fieldType]: value };
            return {
                ...prev,
                [section]: { ...prev[section], cta: ctaArray }
            };
        });
    };

    const handleAddHeaderCta = (section = "headerSection") => {
        setFormData((prev) => ({
            ...prev,
            [section]: {
                ...(prev[section] || {}),
                cta: [...(prev[section]?.cta || []), { name: '', link: '' }]
            }
        }));
    };

    const handleRemoveHeaderCta = (idx, section = "headerSection") => {
        setFormData((prev) => ({
            ...prev,
            [section]: {
                ...(prev[section] || {}),
                cta: (prev[section]?.cta || []).filter((_, i) => i !== idx)
            }
        }));
    };

    const handleChangeHeaderPoint = (value, fieldType, idx) => {
        const pointsArray = [...(formData?.headerSection?.points || [])];
        if (pointsArray[idx]) {
            pointsArray[idx] = { ...pointsArray[idx], [fieldType]: value };
            setFormData((prev) => ({
                ...prev,
                headerSection: { ...prev.headerSection, points: pointsArray }
            }));
        }
    };

    const handleAddHeaderPoint = () => {
        setFormData((prev) => ({
            ...prev,
            headerSection: {
                ...prev.headerSection,
                points: [...(prev.headerSection?.points || []), { name: '', desc: '' }]
            }
        }));
    };

    const handleRemoveHeaderPoint = (idx) => {
        setFormData((prev) => ({
            ...prev,
            headerSection: {
                ...prev.headerSection,
                points: (prev.headerSection?.points || []).filter((_, i) => i !== idx)
            }
        }));
    };

    // ************************************************** Icon Upload **************************************************
    const productImageUploadHandler = async (e, imageType) => {
        const keyParts = imageType.split('.'); // Split the key to access nested object
        console.log("imageType", keyParts[0]);

        if (isUploading) return;
        uploadedImageRef.current = imageType;
        if (e.target.files.length) {
            const file = e.target.files[0];
            const body = new FormData();
            body.append('filePath', file);
            dispatch(uploadImage(body)).unwrap().then((res => {
                const data = {
                    alt: "",
                    title: file?.name,
                    description: "",
                    url: res.fileUrl

                }
                handleModalImage(keyParts[0], data)
                if (keyParts[0] === "compliantCannabisDelivery") {
                    setFormData((prevData) => ({
                        ...prevData,
                        compliantCannabisDelivery: {
                            ...prevData.compliantCannabisDelivery,
                            image: {
                                url: res.fileUrl,
                                title: file?.name,
                                description: "",
                                alt: ""
                            },
                        },
                    }));
                }   if (keyParts[0] === "footerSection")                    {
                    setFormData((prevData) => ({
                        ...prevData,
                        footerSection: {
                            ...prevData.footerSection,
                            section: {
                                ...prevData.footerSection.section,
                                image: {
                                    url: res.fileUrl,
                                    title: file?.name,
                                    description: "",
                                    alt: ""
                                },
                            },
                        },
                    }));
                    } else {
                    setFormData((prevData) => ({
                        ...prevData,
                        headerSection: {
                            ...prevData.headerSection,
                            section: {
                                ...prevData.headerSection.section,
                                image: {
                                    url: res.fileUrl,
                                    title: file?.name,
                                    description: "",
                                    alt: ""
                                },
                            },
                        },
                    }));
                }

            }));
        }
    };

    const handleModalImage = (type, data, index) => {
        dispatch(openCustomModalDialog({
            modal: 'IMAGE_MODAL_SEO',
            modalData: {
                imageContent: type, data, index, fileMediaHandler, cusClass: true
            }
        }))

    }
    const fileMediaHandler = (mediaData, imageContent, index) => {
        console.log("daaikfnokdfj", imageContent);
        if (imageContent === "compliantCannabisDelivery") {
            console.log("daaikfnokdfj", imageContent);

            setFormData((prevData) => ({
                ...prevData,
                [imageContent]: {
                    ...prevData[imageContent],
                    image: mediaData,
                },
            }));
            return
        }
        if (index === undefined) {
            setFormData((prevData) => ({
                ...prevData,
                [imageContent]: {
                    ...prevData[imageContent],
                    section: {
                        ...prevData[imageContent].section,
                        image: mediaData,
                    },
                },
            }));
        }

        else {
            setFormData((prevData) => ({
                ...prevData,
                [imageContent]: {
                    ...prevData[imageContent],
                    section: index !== undefined
                        ? prevData[imageContent].section.map((item, idx) =>
                            idx === index ? { ...item, image: mediaData } : item
                        )
                        : prevData[imageContent].section,
                },
            }));
        }
    };




    const addBanner = (type) => {
        if (type === 'placeholder') {
        } else
            if (type === 'weedDeliveryWorks') {

                setFormData((prev) => ({
                    ...prev,
                    weedDeliveryWorks: {
                        ...prev.weedDeliveryWorks,
                        section: [
                            ...prev.weedDeliveryWorks.section,
                            {
                                title: '',
                                description: '',
                                imageUrl: '',
                            },
                        ],
                    },
                }));
            } else
                if (type === 'dispensaryTrip') {

                    setFormData((prev) => ({
                        ...prev,
                        dispensaryTrip: {
                            ...prev.dispensaryTrip,
                            section: [
                                ...prev.dispensaryTrip.section,
                                {
                                    title: '',
                                    description: '',
                                    imageUrl: '',
                                },
                            ],
                        },
                    }));
                }
                else
                    if (type === 'sameDayDeliveryTiming') {

                        setFormData((prev) => ({
                            ...prev,
                            sameDayDeliveryTiming: {
                                ...prev.sameDayDeliveryTiming,
                                section: [
                                    ...prev.sameDayDeliveryTiming.section,
                                    {
                                        title: '',
                                        description: '',
                                        imageUrl: '',
                                    },
                                ],
                            },
                        }));
                    } else
                        if (type === 'hyperwolfForWeedDelivery') {

                            setFormData((prev) => ({
                                ...prev,
                                hyperwolfForWeedDelivery: {
                                    ...prev.hyperwolfForWeedDelivery,
                                    section: [
                                        ...prev.hyperwolfForWeedDelivery.section,
                                        {
                                            title: '',
                                            description: '',
                                            imageUrl: '',
                                        },
                                    ],
                                },
                            }));
                        } else
                            if (type === 'compliantCannabisDelivery') {

                                setFormData((prev) => ({
                                    ...prev,
                                    compliantCannabisDelivery: {
                                        ...prev.compliantCannabisDelivery,
                                        section: [
                                            ...prev.compliantCannabisDelivery.section,
                                            {
                                                title: '',
                                                description: '',
                                            },
                                        ],
                                    },
                                }));
                            }
    };

    const handleDeleteBanner = (index, sectionType) => {
        if (sectionType === 'weedDeliveryWorks') {
            if (formData.weedDeliveryWorks.section.length) {
                const updatedBanners = formData.weedDeliveryWorks.section.filter((_, i) => i !== index);
                setFormData((prev) => ({
                    ...prev,
                    weedDeliveryWorks: {
                        ...prev.weedDeliveryWorks,
                        section: updatedBanners,
                    },
                }));
            }
        }
        else if (sectionType === 'dispensaryTrip') {
            if (formData.dispensaryTrip.section.length) {
                const updatedBanners = formData.dispensaryTrip.section.filter((_, i) => i !== index);
                setFormData((prev) => ({
                    ...prev,
                    dispensaryTrip: {
                        ...prev.dispensaryTrip,
                        section: updatedBanners,
                    },
                }));
            }
        }

        else if (sectionType === 'sameDayDeliveryTiming') {
            if (formData.sameDayDeliveryTiming.section.length) {
                const updatedBanners = formData.sameDayDeliveryTiming.section.filter((_, i) => i !== index);
                setFormData((prev) => ({
                    ...prev,
                    sameDayDeliveryTiming: {
                        ...prev.sameDayDeliveryTiming,
                        section: updatedBanners,
                    },
                }));
            }
        } else if (sectionType === 'hyperwolfForWeedDelivery') {
            if (formData.hyperwolfForWeedDelivery.section.length) {
                const updatedBanners = formData.hyperwolfForWeedDelivery.section.filter((_, i) => i !== index);
                setFormData((prev) => ({
                    ...prev,
                    hyperwolfForWeedDelivery: {
                        ...prev.hyperwolfForWeedDelivery,
                        section: updatedBanners,
                    },
                }));
            }
        } else if (sectionType === 'compliantCannabisDelivery') {
            if (formData.compliantCannabisDelivery.section.length) {
                const updatedBanners = formData.compliantCannabisDelivery.section.filter((_, i) => i !== index);
                setFormData((prev) => ({
                    ...prev,
                    compliantCannabisDelivery: {
                        ...prev.compliantCannabisDelivery,
                        section: updatedBanners,
                    },
                }));
            }
        }
        else {

        }
    };

    const handleImageUpload = (e, index, sectionType) => {

        const file = e.target.files[0];
        uploadedImageRef.current = sectionType + index;
        if (file) {
            const formData = new FormData();
            formData.append("filePath", file);

            dispatch(uploadImage(formData))
                .unwrap()
                .then((res) => {
                    const data = {
                        alt: "",
                        title: file?.name,
                        description: "",
                        url: res.fileUrl

                    }
                    if (sectionType === 'testimonialsSection') {
                        handleModalImage(sectionType, data, index, 'members')
                    }
                    else {
                        handleModalImage(sectionType, data, index)

                    }
                    if (res?.fileUrl) {
                        updateBannerField(index, "imageUrl", res.fileUrl, sectionType, file?.name);
                    }
                })
                .catch((error) => {
                });
        }
    };

    return (
        <Box p={4} pt={2} className="static-pages-container">
            {/********************** Select Platform/Show On **********************/}
            <Card sx={{ p: { xs: 2, md: 3 }, mb: 2, borderRadius: 2.5, boxShadow: 'none' }}>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        {
                            fullRoleTabSlug &&
                            <Grid container spacing={3}>
                                <Grid item xs={12} md={4}>
                                    <div className="w-100 mb-4">
                                        <Typography variant='h5' fontWeight="semibold" mb={2}>Page Name</Typography>
                                        <TextField
                                            label='Page Name'
                                            fullWidth
                                            variant='outlined'
                                            name='heading'
                                            value={formData?.heading || ''}
                                            className='form-input'
                                            disabled={true}
                                        />
                                    </div>
                                </Grid>
                                {
                                    notSlug &&
                                    <Grid item xs={12} md={4}>
                                        <div className="w-100 mb-4">
                                            <Typography variant='h5' fontWeight="semibold" mb={2}>Page Slug</Typography>
                                            <TextField
                                                label='Page Slug'
                                                fullWidth
                                                variant='outlined'
                                                name='slug'
                                                value={formData?.slug || ''}
                                                onChange={handleChangeSlug}

                                                className='form-input'
                                            />
                                        </div>
                                    </Grid>
                                }
                            </Grid>
                        }
                        <Typography variant='h5' fontWeight="semibold" mb={2}>Visible On</Typography>
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <FormControl sx={{ width: "100%" }}>
                                    <FormGroup className='radio-colors' sx={checkboxGroup}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={formData?.displaySettings?.hamburgerMenu}
                                                    onChange={() => handleShowOnChange('hamburgerMenu')}
                                                />
                                            }
                                            label="Hamburger Menu"
                                        />
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={formData?.displaySettings?.footer}
                                                    onChange={() => handleShowOnChange('footer')}
                                                />
                                            }
                                            label="Footer"
                                        />
                                    </FormGroup>
                                </FormControl>
                                {Boolean(errors?.displaySettings) && <FormHelperText error>{errors?.displaySettings}</FormHelperText>}

                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Card>

            {/********************** Meta Tags **********************/}
            <Card sx={{ p: { xs: 2, md: 3 }, mb: 2, borderRadius: 2.5, boxShadow: 'none' }}>
                <Typography variant='h5' fontWeight="semibold" mb={2}>Meta Properties</Typography>
                <Grid container spacing={3}>
                    <Grid item xs={12} md={12}>
                        <TextField
                            label="Meta Title"
                            className="form-input"
                            fullWidth
                            placeholder="Meta Title"
                            value={formData?.metaProperties?.title}
                            onChange={(e) => setFormData((prev) => ({ ...prev, metaProperties: { ...prev?.metaProperties, title: e.target.value } }))}
                            error={Boolean(errors?.metaProperties?.title)}
                            helperText={errors?.metaProperties?.title}
                        />
                        <span className='drag_drop'>
                            Character Count: {formData?.metaProperties?.title?.length || 0} <span>(Recommended Characters: 60)</span>
                        </span>
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <TextField
                            label="Meta Description"
                            className="form-input"
                            fullWidth
                            placeholder="Meta Description"
                            value={formData?.metaProperties?.description}
                            onChange={(e) => setFormData((prev) => ({ ...prev, metaProperties: { ...prev?.metaProperties, description: e.target.value } }))}
                            error={Boolean(errors?.metaProperties?.description)}
                            helperText={errors?.metaProperties?.description}

                        />
                        <span className='drag_drop'>
                            Character Count: {formData?.metaProperties?.description?.length || 0} <span>(Recommended Characters: 160)</span>
                        </span>
                    </Grid>
                </Grid>
            </Card>

            {/********************** Top Banner **********************/}
            <Accordion expanded={expanded === 'header'} onChange={handleChange('header')}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panelheading-content"
                    id="panelheading-header"
                >
                    <Box display="flex" alignItems="center" gap={1}>
                        <Typography variant='h4' fontWeight="semibold" style={{ color: "#2E2E3A" }}>Header Section</Typography>
                        <FormControlLabel
                            onClick={(e) => e.stopPropagation()}
                            control={
                                <Switch
                                    checked={formData?.headerSection?.status}
                                    onChange={() =>
                                        setFormData((prev) => ({ ...prev, headerSection: { ...prev.headerSection, status: !prev.headerSection.status, } }))
                                    }
                                />
                            }
                            label={formData?.headerSection?.status ? "Visible" : "Hidden"}
                        />
                    </Box>
                </AccordionSummary>
                <AccordionDetails>
                    <Grid container direction="row" justifyContent="center" alignItems="center">
                        <Grid item xs={12} md={6}>
                            <Grid container spacing={3}>
                                <Grid item xs={12}>
                                    <Typography variant='body2' fontWeight="medium" color="#2E2E3A" mb={1}>Page Title(H1)</Typography>
                                    <TextField
                                        label="Page Title(H1)"
                                        className="form-input"
                                        fullWidth
                                        placeholder="Page Title(H1)"
                                        value={formData?.headerSection?.pageTitle}
                                        onChange={(e) =>
                                            setFormData((prev) => ({ ...prev, headerSection: { ...prev.headerSection, pageTitle: e.target.value }, }))
                                        }
                                        error={Boolean(errors?.headerSection?.pageTitle)}
                                        helperText={errors?.headerSection?.pageTitle}
                                    />
                                </Grid>

                                <Grid item xs={12}>
                                    <Typography variant="body2" fontWeight="medium" color="#2E2E3A" mb={1}>Description</Typography>
                                    <CommonQuillEditor
                                        allowHeading={false}
                                        value={formData?.headerSection?.section?.description || ''}
                                        onChange={(value) => setFormData((prev) => ({
                                            ...prev,
                                            headerSection: { ...prev?.headerSection, section: { ...prev?.headerSection?.section, description: value, }, },
                                        }))
                                        }
                                    />
                                    {Boolean(errors?.headerSection?.section?.description) && <FormHelperText error>{errors?.headerSection?.section?.description}</FormHelperText>}
                                </Grid>

                        

                                <Grid item xs={12}>
                                    <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center">
                                        <div>
                                            <Typography className="w-100" variant="body2" fontWeight="medium" color="#2E2E3A" mb={1}>Top Banner</Typography>
                                            <Stack direction='row' alignItems='center' flexWrap='wrap' gap={1.25} className="full-img-sec">
                                                <Badge
                                                    overlap='circular'
                                                    anchorOrigin={{ vertical: 'top', horizontal: 'right', }}
                                                    badgeContent={
                                                        isUploading && uploadedImageRef.current === 'headerSection.section.imageUrl' ? <CircularProgress size={32} color='primary' sx={badgeCircularProgressIcon} /> : ''
                                                    }
                                                >
                                                    {
                                                        formData?.headerSection?.section?.image?.url ?
                                                            <img style={uploadThumbnailImage} onClick={() => handleModalImage("headerSection", formData?.headerSection?.section?.image)} src={formData?.headerSection?.section?.image?.url || defaultImage} alt='documentId' />
                                                            :
                                                            <>
                                                                <label htmlFor='headerSectionImage-input' className='add-change-image'>
                                                                    <MDButton
                                                                        sx={{ minWidth: '180px' }}
                                                                        type='button'
                                                                        variant='outlined'
                                                                        color='secondary'
                                                                        component='span'
                                                                        disabled={isUploading}
                                                                    >
                                                                        <div className='add-change-img-sec'>
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                                                                <g clipPath="url(#clip0_13676_49992)">
                                                                                    <path d="M14.2274 15.8545C14.1173 15.8547 14.0086 15.8296 13.9089 15.781C13.8093 15.7324 13.7211 15.6615 13.6508 15.5733L12.7504 14.4479V21.8603C12.7504 22.0675 12.6714 22.2662 12.5308 22.4127C12.3901 22.5592 12.1993 22.6416 12.0004 22.6416C11.8015 22.6416 11.6107 22.5592 11.4701 22.4127C11.3294 22.2662 11.2504 22.0675 11.2504 21.8603V14.4479L10.35 15.5733C10.2872 15.6529 10.2099 15.7187 10.1226 15.767C10.0352 15.8153 9.93958 15.8452 9.84113 15.8548C9.74267 15.8645 9.64336 15.8538 9.5489 15.8233C9.45444 15.7928 9.36669 15.7431 9.29072 15.6772C9.21475 15.6113 9.15205 15.5303 9.10623 15.439C9.0604 15.3477 9.03236 15.2479 9.02372 15.1453C9.01508 15.0427 9.026 14.9393 9.05586 14.8411C9.08572 14.7429 9.13393 14.6518 9.19772 14.5731L11.4243 11.7899C11.4947 11.7019 11.5828 11.6311 11.6823 11.5825C11.7819 11.5339 11.8905 11.5088 12.0005 11.5088C12.1104 11.5088 12.219 11.5339 12.3186 11.5825C12.4182 11.6311 12.5063 11.7019 12.5767 11.7899L14.8032 14.5731C14.8945 14.6871 14.9526 14.8259 14.9709 14.9731C14.9891 15.1204 14.9667 15.27 14.9063 15.4044C14.8459 15.5389 14.75 15.6526 14.6297 15.7323C14.5095 15.812 14.37 15.8544 14.2275 15.8545H14.2274ZM22.8011 10.8044C22.1571 9.92076 21.2996 9.23086 20.316 8.80513C20.2817 7.43372 19.8323 6.10864 19.0322 5.01895C18.1059 3.76256 16.7356 2.87852 15.1739 2.52965C11.3639 1.67882 7.26309 4.1002 6.03267 7.9274L5.89955 8.34156C4.32962 8.35074 2.82723 9.00795 1.72172 10.1691C0.616204 11.3303 -0.00223194 12.9007 0.00197444 14.536C0.00618083 16.1714 0.632686 17.7383 1.74416 18.8933C2.85563 20.0483 4.36137 20.6971 5.93133 20.6975H9.36385C9.56276 20.6975 9.75352 20.6152 9.89418 20.4687C10.0348 20.3222 10.1138 20.1235 10.1138 19.9163C10.1138 19.7091 10.0348 19.5104 9.89418 19.3638C9.75352 19.2173 9.56276 19.135 9.36385 19.135H5.93133C4.75618 19.135 3.62916 18.6487 2.7982 17.7832C1.96725 16.9176 1.50042 15.7436 1.50042 14.5195C1.50042 13.2954 1.96725 12.1214 2.7982 11.2558C3.62916 10.3902 4.75618 9.90396 5.93133 9.90396H6.43936C6.5966 9.90396 6.74986 9.85248 6.87748 9.7568C7.0051 9.66112 7.10062 9.52607 7.15055 9.37076L7.45524 8.42349C8.45081 5.32657 11.7724 3.36793 14.8597 4.05748C17.3343 4.61011 18.9586 6.76744 18.8097 9.30381C18.7994 9.47937 18.8462 9.65343 18.9426 9.79781C19.0391 9.9422 19.1794 10.0485 19.341 10.0994C21.2011 10.6849 22.5004 12.5025 22.5004 14.5195C22.4991 15.7432 22.0318 16.9164 21.2012 17.7816C20.3705 18.6469 19.2443 19.1336 18.0695 19.135H14.637C14.4381 19.135 14.2473 19.2173 14.1067 19.3638C13.966 19.5104 13.887 19.7091 13.887 19.9163C13.887 20.1235 13.966 20.3222 14.1067 20.4687C14.2473 20.6152 14.4381 20.6975 14.637 20.6975H18.0695C19.6419 20.6957 21.1495 20.0442 22.2613 18.886C23.3732 17.7278 23.9986 16.1574 24.0004 14.5195C24.003 13.1776 23.5816 11.8721 22.8011 10.8044Z" fill="#2E2E3A" />
                                                                                </g>
                                                                                <defs>
                                                                                    <clipPath id="clip0_13676_49992">
                                                                                        <rect width="24" height="25" fill="white" />
                                                                                    </clipPath>
                                                                                </defs>
                                                                            </svg>
                                                                            <h5>Add Image</h5>
                                                                        </div>

                                                                    </MDButton>
                                                                </label></>
                                                    }
                                                </Badge>
                                                {formData?.headerSection?.section?.image?.url &&

                                                    <label htmlFor='headerSectionImage-input' className='upload-change-image'>
                                                        <MDButton
                                                            sx={{ minWidth: '180px' }}
                                                            type='button'
                                                            variant='outlined'
                                                            color='secondary'
                                                            component='span'
                                                            disabled={isUploading}
                                                        >
                                                            <div className='add-change-img-sec'>
                                                                <p>Change Image</p>
                                                            </div>
                                                        </MDButton>
                                                    </label>
                                                }
                                                <MDInput
                                                    id='headerSectionImage-input'
                                                    type='file'
                                                    name='headerSectionImage'
                                                    onChange={(e) => productImageUploadHandler(e, 'headerSection.section.imageUrl')}
                                                    fullWidth
                                                    disabled={isUploading}
                                                    style={{ display: 'none' }}
                                                />
                                                {Boolean(errors?.headerSection?.section?.image?.url) && <FormHelperText sx={{ width: '100%', ml: 0, mt: -.5 }} error>{errors?.headerSection?.section?.image?.url}</FormHelperText>}
                                            </Stack>
                                        </div>
                                    </Box>
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography variant='body2' fontWeight="medium" color="#2E2E3A" mb={1}>CTA Buttons</Typography>
                                    {formData?.headerSection?.cta?.map((cta, idx) => (
                                        <Card key={idx} sx={{ p: 2, mb: 2, boxShadow: '0 0 1px rgb(0 0 0 / 20%)' }}>
                                            <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
                                                <Typography variant='body2' fontWeight="medium" color="#2E2E3A">Button {idx + 1}</Typography>
                                                { (
                                                    <MDButton
                                                        sx={{ minWidth: 'auto', p: 0 }}
                                                        size="small"
                                                        variant='text'
                                                        onClick={() => handleRemoveHeaderCta(idx,"headerSection")}
                                                        style={{ color: "#fd4438" }}
                                                    >
                                                        <DeleteIcon width="1rem" height="1rem" style={{ color: "#fd4438" }} />
                                                    </MDButton>
                                                )}
                                            </Box>
                                            <Grid container spacing={3}>
                                                <Grid item xs={12} md={6}>
                                                    <Typography variant='body2' fontWeight="medium" color="#2E2E3A" mb={1}>Button Name</Typography>
                                                    <TextField
                                                        label="Button Name"
                                                        className="form-input"
                                                        fullWidth
                                                        placeholder="e.g. Shop Same Day Delivery"
                                                        value={cta?.name || ''}
                                                        onChange={(e) => handleChangeHeaderCta(e.target.value, 'name', idx)}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} md={6}>
                                                    <Typography variant='body2' fontWeight="medium" color="#2E2E3A" mb={1}>Button Link</Typography>
                                                    <TextField
                                                        label="Button Link"
                                                        className="form-input"
                                                        fullWidth
                                                        placeholder="e.g. https://hyperwolf.com/shop"
                                                        value={cta?.link || ''}
                                                        onChange={(e) => handleChangeHeaderCta(e.target.value, 'link', idx)}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Card>
                                    ))}
                                    <MDButton
                                        type='button'
                                        color='primary'
                                        size='medium'
                                        variant='outlined'
                                        sx={{ minWidth: '180px' }}
                                        onClick={()=>handleAddHeaderCta("headerSection")}
                                    >
                                        <Icon>add</Icon>&nbsp;Add CTA
                                    </MDButton>
                                </Grid>

                                <Grid item xs={12}>
                                    <Typography variant='body2' fontWeight="medium" color="#2E2E3A" mb={1}>Feature Points</Typography>
                                    {formData?.headerSection?.points?.map((point, idx) => (
                                        <Card key={idx} sx={{ p: 2, mb: 2, boxShadow: '0 0 1px rgb(0 0 0 / 20%)' }}>
                                            <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
                                                <Typography variant='body2' fontWeight="medium" color="#2E2E3A">Point {idx + 1}</Typography>
                                                { (
                                                    <MDButton
                                                        sx={{ minWidth: 'auto', p: 0 }}
                                                        size="small"
                                                        variant='text'
                                                        onClick={() => handleRemoveHeaderPoint(idx)}
                                                        style={{ color: "#fd4438" }}
                                                    >
                                                        <DeleteIcon width="1rem" height="1rem" style={{ color: "#fd4438" }} />
                                                    </MDButton>
                                                )}
                                            </Box>
                                            <Grid container spacing={3}>
                                                <Grid item xs={12} md={6}>
                                                    <Typography variant='body2' fontWeight="medium" color="#2E2E3A" mb={1}>Title</Typography>
                                                    <TextField
                                                        label="Title"
                                                        className="form-input"
                                                        fullWidth
                                                        placeholder="e.g. Over 2 Million"
                                                        value={point?.name || ''}
                                                        onChange={(e) => handleChangeHeaderPoint(e.target.value, 'name', idx)}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} md={6}>
                                                    <Typography variant='body2' fontWeight="medium" color="#2E2E3A" mb={1}>Description</Typography>
                                                    <TextField
                                                        label="Description"
                                                        className="form-input"
                                                        fullWidth
                                                        placeholder="e.g. Successful Deliveries"
                                                        value={point?.desc || ''}
                                                        onChange={(e) => handleChangeHeaderPoint(e.target.value, 'desc', idx)}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Card>
                                    ))}
                                    <MDButton
                                        type='button'
                                        color='primary'
                                        size='medium'
                                        variant='outlined'
                                        sx={{ minWidth: '180px' }}
                                        onClick={handleAddHeaderPoint}
                                    >
                                        <Icon>add</Icon>&nbsp;Add Point
                                    </MDButton>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </AccordionDetails>
            </Accordion>
            {/**********************What happens if an item is missing or incorrect? Section **********************/}
            <Accordion expanded={expanded === 'dispensaryTrip'} onChange={handleChange('dispensaryTrip')}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panelalternating-content"
                    id="panelalternating-header"
                >
                    <Box display="flex" alignItems="center" gap={1}>
                        <Typography variant='h4' fontWeight="semibold" style={{ color: "#2E2E3A" }}>Cannabis Delivery Today, Without the Dispensary Trip
                        </Typography>
                        <FormControlLabel
                            onClick={(e) => e.stopPropagation()}
                            control={
                                <Switch
                                    checked={formData?.dispensaryTrip?.status}
                                    onChange={() => setFormData((prev) => ({ ...prev, dispensaryTrip: { ...prev.dispensaryTrip, status: !prev.dispensaryTrip.status, } }))}
                                />
                            }
                            label={formData?.dispensaryTrip?.status ? "Visible" : "Hidden"}
                        />
                    </Box>
                </AccordionSummary>

                <AccordionDetails>
                    <Grid container spacing={3} mb={4} className="full-img-sec">
                        <Grid item xs={12} md={4}>
                            <Typography variant="body2" fontWeight="medium" color="#2E2E3A" mb={1}>Section Title(H2)</Typography>
                            <TextField
                                label="Section Title(H2)"
                                className="form-input"
                                fullWidth
                                placeholder="Section Title(H2)"
                                value={formData?.dispensaryTrip?.pageTitle}
                                onChange={(e) => setFormData((prev) => ({ ...prev, dispensaryTrip: { ...prev.dispensaryTrip, pageTitle: e.target.value }, }))}
                                error={Boolean(errors?.dispensaryTrip?.pageTitle)}
                                helperText={errors?.dispensaryTrip?.pageTitle}

                            />
                        </Grid>
                        <Grid item xs={12} md={8}>
                            <Typography variant="body2" fontWeight="medium" color="#2E2E3A" mb={1}>Description</Typography>
                            <TextField
                                label="Description"
                                className="form-input"
                                fullWidth
                                placeholder="Description"
                                value={formData?.dispensaryTrip?.description}
                                onChange={(e) => setFormData((prev) => ({ ...prev, dispensaryTrip: { ...prev.dispensaryTrip, description: e.target.value }, }))}
                                error={Boolean(errors?.dispensaryTrip?.description)}
                                helperText={errors?.dispensaryTrip?.description}

                            />
                        </Grid>
                    </Grid>

                    {/* Render All Banners Dynamically */}
                    <div className="no-alernative-sections">
                        {formData?.dispensaryTrip?.section?.map((banner, index) => (
                            <Card sx={{ p: 3, mb: 2, borderRadius: 2.5, boxShadow: 'none' }} key={index}
                                style={{
                                    borderRadius: "18px",
                                    border: "1px solid #F1F1F1"
                                }}
                            >
                                <Box
                                    display="flex"
                                    alignItems="center"
                                    justifyContent="end"
                                    style={{
                                        position: "absolute",
                                        top: "24px",
                                        right: "24px",
                                        width: "24px",
                                        height: "24px"
                                    }}
                                >
                                    <MDButton
                                        sx={{ minWidth: 'auto', p: 0 }}
                                        size="small"
                                        variant='text'
                                        onClick={() => handleDeleteBanner(index, 'dispensaryTrip')}
                                        color="error"
                                    >
                                        <DeleteIcon width="1rem" height="1rem" />
                                    </MDButton>
                                </Box>
                                <div className="st-block-sec">
                                    <div className="st-img-sec">
                                        <Typography variant="body2" fontWeight="medium" color="#2E2E3A" mb={1}>Icon {index + 1}</Typography>
                                        {/* Icon Upload */}
                                        <Stack direction='row' alignItems='center' flexWrap='wrap' gap={1.25} className="image-sec">
                                            <Badge
                                                overlap='circular'
                                                anchorOrigin={{ vertical: 'top', horizontal: 'right', }}
                                                badgeContent={isUploading && uploadedImageRef.current === `dispensaryTrip${index}` ? <CircularProgress size={32} color='primary' /> : ''}
                                            >
                                                {
                                                    banner.image?.url ?
                                                        <img className="small-icon" key={banner.image?.url} onClick={() => handleModalImage("dispensaryTrip", banner.image, index)} style={uploadThumbnailImage} src={banner.image?.url || defaultImage} alt='banner' />
                                                        :
                                                        <>
                                                            <label htmlFor={`dispensaryTrip-${index}`} className='add-change-image'>
                                                                <MDButton
                                                                    type='button'
                                                                    variant='outlined'
                                                                    color='secondary'
                                                                    component='span'
                                                                    disabled={isUploading}
                                                                >
                                                                    <div className='add-change-img-sec'>
                                                                        <img src="/images/add-iocn.svg" />
                                                                        <h5>Add Icon</h5>
                                                                    </div>
                                                                </MDButton>
                                                            </label>
                                                        </>
                                                }
                                            </Badge>
                                            {
                                                banner.image?.url &&
                                                <label htmlFor={`dispensaryTrip-${index}`} className='upload-change-image'>
                                                    <MDButton
                                                        type='button'
                                                        variant='outlined'
                                                        color='secondary'
                                                        component='span'
                                                        disabled={isUploading}
                                                    >
                                                        <div className='add-change-img-sec'>
                                                            <p>Change File</p>
                                                        </div>
                                                    </MDButton>
                                                </label>
                                            }
                                            <MDInput
                                                id={`dispensaryTrip-${index}`}
                                                type='file'
                                                name='categoryImage'
                                                onChange={(e) => handleImageUpload(e, index, 'dispensaryTrip')}
                                                fullWidth
                                                disabled={isUploading}
                                                style={{ display: 'none' }}
                                            />
                                            {Boolean(errors?.dispensaryTrip?.section[index]?.image?.url) && <FormHelperText sx={{ width: '100%', ml: 0, mt: -.5 }} error>{errors?.dispensaryTrip?.section[index]?.image?.url}</FormHelperText>}
                                        </Stack>
                                    </div>
                                    <div className="st-contents-sec">
                                        <Grid container spacing={3}>
                                            <Grid item xs={12} md={6}>
                                                <Typography variant="body2" fontWeight="medium" color="#2E2E3A" mb={1}>Title (H3)</Typography>
                                                <TextField
                                                    label="Title (H3)"
                                                    className="form-input"
                                                    fullWidth
                                                    placeholder="Title (H3)"
                                                    value={banner.title || ''}
                                                    onChange={(e) => updateBannerField(index, 'title', e.target.value, 'dispensaryTrip')}
                                                    error={Boolean(errors?.dispensaryTrip?.section[index]?.title)}
                                                    helperText={errors?.dispensaryTrip?.section[index]?.title}
                                                />
                                                <span className='drag_drop'>
                                                    Character Count: {banner.title?.length || 0} <span>(Max: 60)</span>
                                                </span>
                                            </Grid>


                                            <Grid item xs={12}>
                                                {/* Description */}
                                                <Typography variant="body2" fontWeight="medium" color="#2E2E3A" mb={1}>Description</Typography>
                                                <CommonQuillEditor
                                                    allowHeading={false}
                                                    value={banner.description || ''}
                                                    onChange={(value) => updateBannerField(index, 'description', value, 'dispensaryTrip')}
                                                />
                                                {Boolean(errors?.dispensaryTrip?.section[index]?.description) && (
                                                    <FormHelperText error>{errors?.dispensaryTrip?.section[index]?.description}</FormHelperText>
                                                )}
                                                <span className='drag_drop'>
                                                    Character Count: {banner.description?.length || 0} <span>(Max: 550)</span>
                                                </span>
                                            </Grid>
                                        </Grid>
                                    </div>
                                </div>
                            </Card>
                        ))}
                    </div>

                    {/* Add More Button */}
                    <Grid item xs={12}>
                        <MDButton type='button' color='primary' size='medium' variant='outlined' sx={{ minWidth: '180px' }} onClick={() => addBanner("dispensaryTrip")}>
                            <Icon>add</Icon>&nbsp;Add More
                        </MDButton>
                    </Grid>

                </AccordionDetails>
            </Accordion>

            {/**********************How Same-Day Weed Delivery Works Section **********************/}
            <Accordion expanded={expanded === 'weedDeliveryWorks'} onChange={handleChange('weedDeliveryWorks')}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panelalternating-content"
                    id="panelalternating-header"
                >
                    <Box display="flex" alignItems="center" gap={1}>
                        <Typography variant='h4' fontWeight="semibold" style={{ color: "#2E2E3A" }}>How Same-Day Weed Delivery Works

                        </Typography>
                        <FormControlLabel
                            onClick={(e) => e.stopPropagation()}
                            control={
                                <Switch
                                    checked={formData?.weedDeliveryWorks?.status}
                                    onChange={() => setFormData((prev) => ({ ...prev, weedDeliveryWorks: { ...prev.weedDeliveryWorks, status: !prev.weedDeliveryWorks.status, } }))}
                                />
                            }
                            label={formData?.weedDeliveryWorks?.status ? "Visible" : "Hidden"}
                        />
                    </Box>
                </AccordionSummary>

                <AccordionDetails>
                    <Grid container spacing={3} mb={4} className="full-img-sec">
                        <Grid item xs={12} md={4}>
                            <Typography variant="body2" fontWeight="medium" color="#2E2E3A" mb={1}>Section Title(H2)</Typography>
                            <TextField
                                label="Section Title(H2)"
                                className="form-input"
                                fullWidth
                                placeholder="Section Title(H2)"
                                value={formData?.weedDeliveryWorks?.pageTitle}
                                onChange={(e) => setFormData((prev) => ({ ...prev, weedDeliveryWorks: { ...prev.weedDeliveryWorks, pageTitle: e.target.value }, }))}
                                error={Boolean(errors?.weedDeliveryWorks?.pageTitle)}
                                helperText={errors?.weedDeliveryWorks?.pageTitle}
                            />
                        </Grid>
                        {/* <Grid item xs={12} md={4}>
                            <Typography variant="body2" fontWeight="medium" color="#2E2E3A" mb={1}>Description(p)</Typography>
                            <TextField
                                label="Description(p)"
                                className="form-input"
                                fullWidth
                                placeholder="Description(p)"
                                value={formData?.weedDeliveryWorks?.description}
                                onChange={(e) => setFormData((prev) => ({ ...prev, weedDeliveryWorks: { ...prev.weedDeliveryWorks, description: e.target.value }, }))}
                                error={Boolean(errors?.weedDeliveryWorks?.description)}
                                helperText={errors?.weedDeliveryWorks?.description}
                            />
                        </Grid> */}
                    </Grid>

                    {/* Render All Banners Dynamically */}
                    <div className="no-alernative-sections">
                        {formData?.weedDeliveryWorks?.section?.map((banner, index) => (
                            <Card sx={{ p: 3, mb: 2, borderRadius: 2.5, boxShadow: 'none' }} key={index}
                                style={{
                                    borderRadius: "18px",
                                    border: "1px solid #F1F1F1"
                                }}
                            >
                                <Box
                                    display="flex"
                                    alignItems="center"
                                    justifyContent="end"
                                    style={{
                                        position: "absolute",
                                        top: "24px",
                                        right: "24px",
                                        width: "24px",
                                        height: "24px"
                                    }}
                                >
                                    <MDButton
                                        sx={{ minWidth: 'auto', p: 0 }}
                                        size="small"
                                        variant='text'
                                        onClick={() => handleDeleteBanner(index, 'weedDeliveryWorks')}
                                        color="error"
                                    >
                                        <DeleteIcon width="1rem" height="1rem" />
                                    </MDButton>
                                </Box>
                                <div className="st-block-sec">
                                    <div className="st-img-sec">
                                        <Typography variant="body2" fontWeight="medium" color="#2E2E3A" mb={1}>Icon {index + 1}</Typography>
                                        {/* Icon Upload */}
                                        <Stack direction='row' alignItems='center' flexWrap='wrap' gap={1.25} className="image-sec">
                                            <Badge
                                                overlap='circular'
                                                anchorOrigin={{ vertical: 'top', horizontal: 'right', }}
                                                badgeContent={isUploading && uploadedImageRef.current === `weedDeliveryWorks${index}` ? <CircularProgress size={32} color='primary' /> : ''}
                                            >
                                                {
                                                    banner.image?.url ?
                                                        <img className="small-icon" key={banner.image?.url} onClick={() => handleModalImage("weedDeliveryWorks", banner.image, index)} style={uploadThumbnailImage} src={banner.image?.url || defaultImage} alt='banner' />
                                                        :
                                                        <>
                                                            <label htmlFor={`weedDeliveryWorks-${index}`} className='add-change-image'>
                                                                <MDButton
                                                                    type='button'
                                                                    variant='outlined'
                                                                    color='secondary'
                                                                    component='span'
                                                                    disabled={isUploading}
                                                                >
                                                                    <div className='add-change-img-sec'>
                                                                        <img src="/images/add-iocn.svg" />
                                                                        <h5>Add Icon</h5>
                                                                    </div>
                                                                </MDButton>
                                                            </label>
                                                        </>
                                                }
                                            </Badge>
                                            {
                                                banner.image?.url &&
                                                <label htmlFor={`weedDeliveryWorks-${index}`} className='upload-change-image'>
                                                    <MDButton
                                                        type='button'
                                                        variant='outlined'
                                                        color='secondary'
                                                        component='span'
                                                        disabled={isUploading}
                                                    >
                                                        <div className='add-change-img-sec'>
                                                            <p>Change File</p>
                                                        </div>
                                                    </MDButton>
                                                </label>
                                            }
                                            <MDInput
                                                id={`weedDeliveryWorks-${index}`}
                                                type='file'
                                                name='categoryImage'
                                                onChange={(e) => handleImageUpload(e, index, 'weedDeliveryWorks')}
                                                fullWidth
                                                disabled={isUploading}
                                                style={{ display: 'none' }}
                                            />
                                            {Boolean(errors?.weedDeliveryWorks?.section[index]?.image?.url) && <FormHelperText sx={{ width: '100%', ml: 0, mt: -.5 }} error>{errors?.weedDeliveryWorks?.section[index]?.image?.url}</FormHelperText>}
                                        </Stack>
                                    </div>
                                    <div className="st-contents-sec">
                                        <Grid container spacing={3}>

                                            <Grid item xs={12} md={6}>
                                                <Typography variant="body2" fontWeight="medium" color="#2E2E3A" mb={1}>Title (H3)</Typography>
                                                <TextField
                                                    label="Title (H3)"
                                                    className="form-input"
                                                    fullWidth
                                                    placeholder="Title (H3)"
                                                    value={banner.title || ''}
                                                    onChange={(e) => updateBannerField(index, 'title', e.target.value, 'weedDeliveryWorks')}
                                                    error={Boolean(errors?.weedDeliveryWorks?.section[index]?.title)}
                                                    helperText={errors?.weedDeliveryWorks?.section[index]?.title}
                                                />
                                                <span className='drag_drop'>
                                                    Character Count: {banner.title?.length || 0} <span>(Max: 60)</span>
                                                </span>
                                            </Grid>

                                            <Grid item xs={12}>
                                                {/* Description */}
                                                <Typography variant="body2" fontWeight="medium" color="#2E2E3A" mb={1}>Description</Typography>
                                                <CommonQuillEditor
                                                    allowHeading={false}
                                                    value={banner.description || ''}
                                                    onChange={(value) => updateBannerField(index, 'description', value, 'weedDeliveryWorks')}
                                                />
                                                {Boolean(errors?.weedDeliveryWorks?.section[index]?.description) && (
                                                    <FormHelperText error>{errors?.weedDeliveryWorks?.section[index]?.description}</FormHelperText>
                                                )}
                                                <span className='drag_drop'>
                                                    Character Count: {banner.description?.length || 0} <span>(Max: 550)</span>
                                                </span>
                                            </Grid>
                                        </Grid>
                                    </div>
                                </div>
                            </Card>
                        ))}
                    </div>

                    {/* Add More Button */}
                    <Grid item xs={12}>
                        <MDButton type='button' color='primary' size='medium' variant='outlined' sx={{ minWidth: '180px' }} onClick={() => addBanner("weedDeliveryWorks")}>
                            <Icon>add</Icon>&nbsp;Add More
                        </MDButton>
                    </Grid>

                </AccordionDetails>
            </Accordion>
            {/**********************Same-Day Delivery Timing **********************/}
            <Accordion expanded={expanded === 'sameDayDeliveryTiming'} onChange={handleChange('sameDayDeliveryTiming')}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panelalternating-content"
                    id="panelalternating-header"
                >
                    <Box display="flex" alignItems="center" gap={1}>
                        <Typography variant='h4' fontWeight="semibold" style={{ color: "#2E2E3A" }}>Same-Day Delivery Timing


                        </Typography>
                        <FormControlLabel
                            onClick={(e) => e.stopPropagation()}
                            control={
                                <Switch
                                    checked={formData?.sameDayDeliveryTiming?.status}
                                    onChange={() => setFormData((prev) => ({ ...prev, sameDayDeliveryTiming: { ...prev.sameDayDeliveryTiming, status: !prev.sameDayDeliveryTiming.status, } }))}
                                />
                            }
                            label={formData?.sameDayDeliveryTiming?.status ? "Visible" : "Hidden"}
                        />
                    </Box>
                </AccordionSummary>

                <AccordionDetails>
                    <Grid container spacing={3} mb={4} className="full-img-sec">
                        <Grid item xs={12} md={4}>
                            <Typography variant="body2" fontWeight="medium" color="#2E2E3A" mb={1}>Section Title(H2)</Typography>
                            <TextField
                                label="Section Title(H2)"
                                className="form-input"
                                fullWidth
                                placeholder="Section Title(H2)"
                                value={formData?.sameDayDeliveryTiming?.pageTitle}
                                onChange={(e) => setFormData((prev) => ({ ...prev, sameDayDeliveryTiming: { ...prev.sameDayDeliveryTiming, pageTitle: e.target.value }, }))}
                                error={Boolean(errors?.sameDayDeliveryTiming?.pageTitle)}
                                helperText={errors?.sameDayDeliveryTiming?.pageTitle}
                            />
                        </Grid>
                        {/* <Grid item xs={12} md={4}>
              <Typography variant="body2" fontWeight="medium" color="#2E2E3A" mb={1}>Description(p)</Typography>
              <TextField
                  label="Description(p)"
                  className="form-input"
                  fullWidth
                  placeholder="Description(p)"
                  value={formData?.sameDayDeliveryTiming?.description}
                  onChange={(e) => setFormData((prev) => ({ ...prev, sameDayDeliveryTiming: { ...prev.sameDayDeliveryTiming, description: e.target.value }, }))}
                  error={Boolean(errors?.sameDayDeliveryTiming?.description)}
                  helperText={errors?.sameDayDeliveryTiming?.description}
              />
          </Grid> */}
                    </Grid>

                    {/* Render All Banners Dynamically */}
                    <div className="no-alernative-sections">
                        {formData?.sameDayDeliveryTiming?.section?.map((banner, index) => (
                            <Card sx={{ p: 3, mb: 2, borderRadius: 2.5, boxShadow: 'none' }} key={index}
                                style={{
                                    borderRadius: "18px",
                                    border: "1px solid #F1F1F1"
                                }}
                            >
                                <Box
                                    display="flex"
                                    alignItems="center"
                                    justifyContent="end"
                                    style={{
                                        position: "absolute",
                                        top: "24px",
                                        right: "24px",
                                        width: "24px",
                                        height: "24px"
                                    }}
                                >
                                    <MDButton
                                        sx={{ minWidth: 'auto', p: 0 }}
                                        size="small"
                                        variant='text'
                                        onClick={() => handleDeleteBanner(index, 'sameDayDeliveryTiming')}
                                        color="error"
                                    >
                                        <DeleteIcon width="1rem" height="1rem" />
                                    </MDButton>
                                </Box>
                                <div className="st-block-sec">
                                    <div className="st-img-sec">
                                        <Typography variant="body2" fontWeight="medium" color="#2E2E3A" mb={1}>Icon {index + 1}</Typography>
                                        {/* Icon Upload */}
                                        <Stack direction='row' alignItems='center' flexWrap='wrap' gap={1.25} className="image-sec">
                                            <Badge
                                                overlap='circular'
                                                anchorOrigin={{ vertical: 'top', horizontal: 'right', }}
                                                badgeContent={isUploading && uploadedImageRef.current === `sameDayDeliveryTiming${index}` ? <CircularProgress size={32} color='primary' /> : ''}
                                            >
                                                {
                                                    banner.image?.url ?
                                                        <img className="small-icon" key={banner.image?.url} onClick={() => handleModalImage("sameDayDeliveryTiming", banner.image, index)} style={uploadThumbnailImage} src={banner.image?.url || defaultImage} alt='banner' />
                                                        :
                                                        <>
                                                            <label htmlFor={`sameDayDeliveryTiming-${index}`} className='add-change-image'>
                                                                <MDButton
                                                                    type='button'
                                                                    variant='outlined'
                                                                    color='secondary'
                                                                    component='span'
                                                                    disabled={isUploading}
                                                                >
                                                                    <div className='add-change-img-sec'>
                                                                        <img src="/images/add-iocn.svg" />
                                                                        <h5>Add Icon</h5>
                                                                    </div>
                                                                </MDButton>
                                                            </label>
                                                        </>
                                                }
                                            </Badge>
                                            {
                                                banner.image?.url &&
                                                <label htmlFor={`sameDayDeliveryTiming-${index}`} className='upload-change-image'>
                                                    <MDButton
                                                        type='button'
                                                        variant='outlined'
                                                        color='secondary'
                                                        component='span'
                                                        disabled={isUploading}
                                                    >
                                                        <div className='add-change-img-sec'>
                                                            <p>Change File</p>
                                                        </div>
                                                    </MDButton>
                                                </label>
                                            }
                                            <MDInput
                                                id={`sameDayDeliveryTiming-${index}`}
                                                type='file'
                                                name='categoryImage'
                                                onChange={(e) => handleImageUpload(e, index, 'sameDayDeliveryTiming')}
                                                fullWidth
                                                disabled={isUploading}
                                                style={{ display: 'none' }}
                                            />
                                            {Boolean(errors?.sameDayDeliveryTiming?.section[index]?.image?.url) && <FormHelperText sx={{ width: '100%', ml: 0, mt: -.5 }} error>{errors?.sameDayDeliveryTiming?.section[index]?.image?.url}</FormHelperText>}
                                        </Stack>
                                    </div>
                                    <div className="st-contents-sec">
                                        <Grid container spacing={3}>

                                            <Grid item xs={12} md={6}>
                                                <Typography variant="body2" fontWeight="medium" color="#2E2E3A" mb={1}>Title (H3)</Typography>
                                                <TextField
                                                    label="Title (H3)"
                                                    className="form-input"
                                                    fullWidth
                                                    placeholder="Title (H3)"
                                                    value={banner.title || ''}
                                                    onChange={(e) => updateBannerField(index, 'title', e.target.value, 'sameDayDeliveryTiming')}
                                                    error={Boolean(errors?.sameDayDeliveryTiming?.section[index]?.title)}
                                                    helperText={errors?.sameDayDeliveryTiming?.section[index]?.title}
                                                />
                                                <span className='drag_drop'>
                                                    Character Count: {banner.title?.length || 0} <span>(Max: 60)</span>
                                                </span>
                                            </Grid>

                                            <Grid item xs={12}>
                                                {/* Description */}
                                                <Typography variant="body2" fontWeight="medium" color="#2E2E3A" mb={1}>Description</Typography>
                                                <CommonQuillEditor
                                                    allowHeading={false}
                                                    value={banner.description || ''}
                                                    onChange={(value) => updateBannerField(index, 'description', value, 'sameDayDeliveryTiming')}
                                                />
                                                {Boolean(errors?.sameDayDeliveryTiming?.section[index]?.description) && (
                                                    <FormHelperText error>{errors?.sameDayDeliveryTiming?.section[index]?.description}</FormHelperText>
                                                )}
                                                <span className='drag_drop'>
                                                    Character Count: {banner.description?.length || 0} <span>(Max: 550)</span>
                                                </span>
                                            </Grid>
                                        </Grid>
                                    </div>
                                </div>
                            </Card>
                        ))}
                    </div>

                    {/* Add More Button */}
                    <Grid item xs={12}>
                        <MDButton type='button' color='primary' size='medium' variant='outlined' sx={{ minWidth: '180px' }} onClick={() => addBanner("sameDayDeliveryTiming")}>
                            <Icon>add</Icon>&nbsp;Add More
                        </MDButton>
                    </Grid>

                </AccordionDetails>
            </Accordion>
            {/********************** Same-Day Weed Delivery Areas**********************/}
            <Accordion expanded={expanded === 'deliveryAreas'} onChange={handleChange('deliveryAreas')}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panelheading-content"
                    id="panelheading-deliveryAreas"
                >
                    <Box display="flex" alignItems="center" gap={1}>
                        <Typography variant='h4' fontWeight="semibold" style={{ color: "#2E2E3A" }}>Same-Day Weed Delivery Areas
                        </Typography>
                        <FormControlLabel
                            onClick={(e) => e.stopPropagation()}
                            control={
                                <Switch
                                    checked={formData?.deliveryAreas?.status}
                                    onChange={() =>
                                        setFormData((prev) => ({ ...prev, deliveryAreas: { ...prev.deliveryAreas, status: !prev.deliveryAreas.status, } }))
                                    }
                                />
                            }
                            label={formData?.deliveryAreas?.status ? "Visible" : "Hidden"}
                        />
                    </Box>
                </AccordionSummary>
                <AccordionDetails>
                    <Grid container direction="row" justifyContent="center" alignItems="center">
                        <Grid item xs={12} md={6}>
                            <Grid container spacing={3}>
                                <Grid item xs={12}>
                                    <Typography variant='body2' fontWeight="medium" color="#2E2E3A" mb={1}>Page Title(H1)</Typography>
                                    <TextField
                                        label="Page Title(H1)"
                                        className="form-input"
                                        fullWidth
                                        placeholder="Page Title(H1)"
                                        value={formData?.deliveryAreas?.pageTitle}
                                        onChange={(e) =>
                                            setFormData((prev) => ({ ...prev, deliveryAreas: { ...prev.deliveryAreas, pageTitle: e.target.value }, }))
                                        }
                                        error={Boolean(errors?.deliveryAreas?.pageTitle)}
                                        helperText={errors?.deliveryAreas?.pageTitle}
                                    />
                                </Grid>

                                <Grid item xs={12}>
                                    <Typography variant="body2" fontWeight="medium" color="#2E2E3A" mb={1}>Description</Typography>
                                    <CommonQuillEditor
                                        allowHeading={false}
                                        value={formData?.deliveryAreas?.description || ''}
                                        onChange={(value) => setFormData((prev) => ({
                                            ...prev,
                                            deliveryAreas: { ...prev?.deliveryAreas, description: value },
                                        }))}
                                    />
                                    {Boolean(errors?.deliveryAreas?.description) && <FormHelperText error>{errors?.deliveryAreas?.description}</FormHelperText>}
                                </Grid>
                          

                            </Grid>
                        </Grid>
                    </Grid>
                </AccordionDetails>
            </Accordion>
            {/**********************Why Choose Hyperwolf for Weed Delivery? Section **********************/}
            <Accordion expanded={expanded === 'hyperwolfForWeedDelivery'} onChange={handleChange('hyperwolfForWeedDelivery')}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panelalternating-content"
                    id="panelalternating-header"
                >
                    <Box display="flex" alignItems="center" gap={1}>
                        <Typography variant='h4' fontWeight="semibold" style={{ color: "#2E2E3A" }}>Why Choose Hyperwolf for Weed Delivery?

                        </Typography>
                        <FormControlLabel
                            onClick={(e) => e.stopPropagation()}
                            control={
                                <Switch
                                    checked={formData?.hyperwolfForWeedDelivery?.status}
                                    onChange={() => setFormData((prev) => ({ ...prev, hyperwolfForWeedDelivery: { ...prev.hyperwolfForWeedDelivery, status: !prev.hyperwolfForWeedDelivery.status, } }))}
                                />
                            }
                            label={formData?.hyperwolfForWeedDelivery?.status ? "Visible" : "Hidden"}
                        />
                    </Box>
                </AccordionSummary>

                <AccordionDetails>
                    <Grid container spacing={3} mb={4} className="full-img-sec">
                        <Grid item xs={12} md={4}>
                            <Typography variant="body2" fontWeight="medium" color="#2E2E3A" mb={1}>Section Title(H2)</Typography>
                            <TextField
                                label="Section Title(H2)"
                                className="form-input"
                                fullWidth
                                placeholder="Section Title(H2)"
                                value={formData?.hyperwolfForWeedDelivery?.pageTitle}
                                onChange={(e) => setFormData((prev) => ({ ...prev, hyperwolfForWeedDelivery: { ...prev.hyperwolfForWeedDelivery, pageTitle: e.target.value }, }))}
                                error={Boolean(errors?.hyperwolfForWeedDelivery?.pageTitle)}
                                helperText={errors?.hyperwolfForWeedDelivery?.pageTitle}

                            />
                        </Grid>

                    </Grid>

                    {/* Render All Banners Dynamically */}
                    <div className="no-alernative-sections">
                        {formData?.hyperwolfForWeedDelivery?.section?.map((banner, index) => (
                            <Card sx={{ p: 3, mb: 2, borderRadius: 2.5, boxShadow: 'none' }} key={index}
                                style={{
                                    borderRadius: "18px",
                                    border: "1px solid #F1F1F1"
                                }}
                            >
                                <Box
                                    display="flex"
                                    alignItems="center"
                                    justifyContent="end"
                                    style={{
                                        position: "absolute",
                                        top: "24px",
                                        right: "24px",
                                        width: "24px",
                                        height: "24px"
                                    }}
                                >
                                    <MDButton
                                        sx={{ minWidth: 'auto', p: 0 }}
                                        size="small"
                                        variant='text'
                                        onClick={() => handleDeleteBanner(index, 'hyperwolfForWeedDelivery')}
                                        color="error"
                                    >
                                        <DeleteIcon width="1rem" height="1rem" />
                                    </MDButton>
                                </Box>
                                <div className="st-block-sec">
                                    <div className="st-img-sec">
                                        <Typography variant="body2" fontWeight="medium" color="#2E2E3A" mb={1}>Icon {index + 1}</Typography>
                                        {/* Icon Upload */}
                                        <Stack direction='row' alignItems='center' flexWrap='wrap' gap={1.25} className="image-sec">
                                            <Badge
                                                overlap='circular'
                                                anchorOrigin={{ vertical: 'top', horizontal: 'right', }}
                                                badgeContent={isUploading && uploadedImageRef.current === `hyperwolfForWeedDelivery${index}` ? <CircularProgress size={32} color='primary' /> : ''}
                                            >
                                                {
                                                    banner.image?.url ?
                                                        <img className="small-icon" key={banner.image?.url} onClick={() => handleModalImage("hyperwolfForWeedDelivery", banner.image, index)} style={uploadThumbnailImage} src={banner.image?.url || defaultImage} alt='banner' />
                                                        :
                                                        <>
                                                            <label htmlFor={`hyperwolfForWeedDelivery-${index}`} className='add-change-image'>
                                                                <MDButton
                                                                    type='button'
                                                                    variant='outlined'
                                                                    color='secondary'
                                                                    component='span'
                                                                    disabled={isUploading}
                                                                >
                                                                    <div className='add-change-img-sec'>
                                                                        <img src="/images/add-iocn.svg" />
                                                                        <h5>Add Icon</h5>
                                                                    </div>
                                                                </MDButton>
                                                            </label>
                                                        </>
                                                }
                                            </Badge>
                                            {
                                                banner.image?.url &&
                                                <label htmlFor={`hyperwolfForWeedDelivery-${index}`} className='upload-change-image'>
                                                    <MDButton
                                                        type='button'
                                                        variant='outlined'
                                                        color='secondary'
                                                        component='span'
                                                        disabled={isUploading}
                                                    >
                                                        <div className='add-change-img-sec'>
                                                            <p>Change File</p>
                                                        </div>
                                                    </MDButton>
                                                </label>
                                            }
                                            <MDInput
                                                id={`hyperwolfForWeedDelivery-${index}`}
                                                type='file'
                                                name='categoryImage'
                                                onChange={(e) => handleImageUpload(e, index, 'hyperwolfForWeedDelivery')}
                                                fullWidth
                                                disabled={isUploading}
                                                style={{ display: 'none' }}
                                            />
                                            {Boolean(errors?.hyperwolfForWeedDelivery?.section[index]?.image?.url) && <FormHelperText sx={{ width: '100%', ml: 0, mt: -.5 }} error>{errors?.hyperwolfForWeedDelivery?.section[index]?.image?.url}</FormHelperText>}
                                        </Stack>
                                    </div>
                                    <div className="st-contents-sec">
                                        <Grid container spacing={3}>
                                            <Grid item xs={12} md={6}>
                                                <Typography variant="body2" fontWeight="medium" color="#2E2E3A" mb={1}>Title (H3)</Typography>
                                                <TextField
                                                    label="Title (H3)"
                                                    className="form-input"
                                                    fullWidth
                                                    placeholder="Title (H3)"
                                                    value={banner.title || ''}
                                                    onChange={(e) => updateBannerField(index, 'title', e.target.value, 'hyperwolfForWeedDelivery')}
                                                    error={Boolean(errors?.hyperwolfForWeedDelivery?.section[index]?.title)}
                                                    helperText={errors?.hyperwolfForWeedDelivery?.section[index]?.title}
                                                />
                                                <span className='drag_drop'>
                                                    Character Count: {banner.title?.length || 0} <span>(Max: 60)</span>
                                                </span>
                                            </Grid>

                                        </Grid>
                                    </div>
                                </div>
                            </Card>
                        ))}
                    </div>

                    {/* Add More Button */}
                    <Grid item xs={12}>
                        <MDButton type='button' color='primary' size='medium' variant='outlined' sx={{ minWidth: '180px' }} onClick={() => addBanner("hyperwolfForWeedDelivery")}>
                            <Icon>add</Icon>&nbsp;Add More
                        </MDButton>
                    </Grid>

                </AccordionDetails>
            </Accordion>
            {/**********************HSafe, Licensed & Compliant Cannabis Delivery Section **********************/}
            <Accordion expanded={expanded === 'compliantCannabisDelivery'} onChange={handleChange('compliantCannabisDelivery')}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panelalternating-content"
                    id="panelalternating-header"
                >
                    <Box display="flex" alignItems="center" gap={1}>
                        <Typography variant='h4' fontWeight="semibold" style={{ color: "#2E2E3A" }}>Safe, Licensed & Compliant Cannabis Delivery


                        </Typography>
                        <FormControlLabel
                            onClick={(e) => e.stopPropagation()}
                            control={
                                <Switch
                                    checked={formData?.compliantCannabisDelivery?.status}
                                    onChange={() => setFormData((prev) => ({ ...prev, compliantCannabisDelivery: { ...prev.compliantCannabisDelivery, status: !prev.compliantCannabisDelivery.status, } }))}
                                />
                            }
                            label={formData?.compliantCannabisDelivery?.status ? "Visible" : "Hidden"}
                        />
                    </Box>
                </AccordionSummary>

                <AccordionDetails>
                    <Grid item xs={12}>
                        <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center">
                            <div>
                                <Typography className="w-100" variant="body2" fontWeight="medium" color="#2E2E3A" mb={1}>Icon</Typography>
                                <Stack direction='row' alignItems='center' flexWrap='wrap' gap={1.25} className="full-img-sec">
                                    <Badge
                                        overlap='circular'
                                        anchorOrigin={{ vertical: 'top', horizontal: 'right', }}
                                        badgeContent={
                                            isUploading && uploadedImageRef.current === 'compliantCannabisDelivery.imageUrl' ? <CircularProgress size={32} color='primary' sx={badgeCircularProgressIcon} /> : ''
                                        }
                                    >
                                        {
                                            formData?.compliantCannabisDelivery?.image?.url ?
                                                <img style={uploadThumbnailImage} onClick={() => handleModalImage("compliantCannabisDelivery", formData?.compliantCannabisDelivery?.image)} src={formData?.compliantCannabisDelivery?.image?.url || defaultImage} alt='documentId' />
                                                :
                                                <>
                                                    <label htmlFor='compliantCannabisDeliveryImage-input' className='add-change-image'>
                                                        <MDButton
                                                            sx={{ minWidth: '180px' }}
                                                            type='button'
                                                            variant='outlined'
                                                            color='secondary'
                                                            component='span'
                                                            disabled={isUploading}
                                                        >
                                                            <div className='add-change-img-sec'>
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                                                    <g clipPath="url(#clip0_13676_49992)">
                                                                        <path d="M14.2274 15.8545C14.1173 15.8547 14.0086 15.8296 13.9089 15.781C13.8093 15.7324 13.7211 15.6615 13.6508 15.5733L12.7504 14.4479V21.8603C12.7504 22.0675 12.6714 22.2662 12.5308 22.4127C12.3901 22.5592 12.1993 22.6416 12.0004 22.6416C11.8015 22.6416 11.6107 22.5592 11.4701 22.4127C11.3294 22.2662 11.2504 22.0675 11.2504 21.8603V14.4479L10.35 15.5733C10.2872 15.6529 10.2099 15.7187 10.1226 15.767C10.0352 15.8153 9.93958 15.8452 9.84113 15.8548C9.74267 15.8645 9.64336 15.8538 9.5489 15.8233C9.45444 15.7928 9.36669 15.7431 9.29072 15.6772C9.21475 15.6113 9.15205 15.5303 9.10623 15.439C9.0604 15.3477 9.03236 15.2479 9.02372 15.1453C9.01508 15.0427 9.026 14.9393 9.05586 14.8411C9.08572 14.7429 9.13393 14.6518 9.19772 14.5731L11.4243 11.7899C11.4947 11.7019 11.5828 11.6311 11.6823 11.5825C11.7819 11.5339 11.8905 11.5088 12.0005 11.5088C12.1104 11.5088 12.219 11.5339 12.3186 11.5825C12.4182 11.6311 12.5063 11.7019 12.5767 11.7899L14.8032 14.5731C14.8945 14.6871 14.9526 14.8259 14.9709 14.9731C14.9891 15.1204 14.9667 15.27 14.9063 15.4044C14.8459 15.5389 14.75 15.6526 14.6297 15.7323C14.5095 15.812 14.37 15.8544 14.2275 15.8545H14.2274ZM22.8011 10.8044C22.1571 9.92076 21.2996 9.23086 20.316 8.80513C20.2817 7.43372 19.8323 6.10864 19.0322 5.01895C18.1059 3.76256 16.7356 2.87852 15.1739 2.52965C11.3639 1.67882 7.26309 4.1002 6.03267 7.9274L5.89955 8.34156C4.32962 8.35074 2.82723 9.00795 1.72172 10.1691C0.616204 11.3303 -0.00223194 12.9007 0.00197444 14.536C0.00618083 16.1714 0.632686 17.7383 1.74416 18.8933C2.85563 20.0483 4.36137 20.6971 5.93133 20.6975H9.36385C9.56276 20.6975 9.75352 20.6152 9.89418 20.4687C10.0348 20.3222 10.1138 20.1235 10.1138 19.9163C10.1138 19.7091 10.0348 19.5104 9.89418 19.3638C9.75352 19.2173 9.56276 19.135 9.36385 19.135H5.93133C4.75618 19.135 3.62916 18.6487 2.7982 17.7832C1.96725 16.9176 1.50042 15.7436 1.50042 14.5195C1.50042 13.2954 1.96725 12.1214 2.7982 11.2558C3.62916 10.3902 4.75618 9.90396 5.93133 9.90396H6.43936C6.5966 9.90396 6.74986 9.85248 6.87748 9.7568C7.0051 9.66112 7.10062 9.52607 7.15055 9.37076L7.45524 8.42349C8.45081 5.32657 11.7724 3.36793 14.8597 4.05748C17.3343 4.61011 18.9586 6.76744 18.8097 9.30381C18.7994 9.47937 18.8462 9.65343 18.9426 9.79781C19.0391 9.9422 19.1794 10.0485 19.341 10.0994C21.2011 10.6849 22.5004 12.5025 22.5004 14.5195C22.4991 15.7432 22.0318 16.9164 21.2012 17.7816C20.3705 18.6469 19.2443 19.1336 18.0695 19.135H14.637C14.4381 19.135 14.2473 19.2173 14.1067 19.3638C13.966 19.5104 13.887 19.7091 13.887 19.9163C13.887 20.1235 13.966 20.3222 14.1067 20.4687C14.2473 20.6152 14.4381 20.6975 14.637 20.6975H18.0695C19.6419 20.6957 21.1495 20.0442 22.2613 18.886C23.3732 17.7278 23.9986 16.1574 24.0004 14.5195C24.003 13.1776 23.5816 11.8721 22.8011 10.8044Z" fill="#2E2E3A" />
                                                                    </g>
                                                                    <defs>
                                                                        <clipPath id="clip0_13676_49992">
                                                                            <rect width="24" height="25" fill="white" />
                                                                        </clipPath>
                                                                    </defs>
                                                                </svg>
                                                                <h5>Add Image</h5>
                                                            </div>

                                                        </MDButton>
                                                    </label></>
                                        }
                                    </Badge>
                                    {formData?.compliantCannabisDelivery?.image?.url &&

                                        <label htmlFor='compliantCannabisDeliveryImage-input' className='upload-change-image'>
                                            <MDButton
                                                sx={{ minWidth: '180px' }}
                                                type='button'
                                                variant='outlined'
                                                color='secondary'
                                                component='span'
                                                disabled={isUploading}
                                            >
                                                <div className='add-change-img-sec'>
                                                    <p>Change Image</p>
                                                </div>
                                            </MDButton>
                                        </label>
                                    }
                                    <MDInput
                                        id='compliantCannabisDeliveryImage-input'
                                        type='file'
                                        name='compliantCannabisDeliveryImage'
                                        onChange={(e) => productImageUploadHandler(e, 'compliantCannabisDelivery.section.imageUrl')}
                                        fullWidth
                                        disabled={isUploading}
                                        style={{ display: 'none' }}
                                    />
                                    {Boolean(errors?.compliantCannabisDelivery?.image?.url) && <FormHelperText sx={{ width: '100%', ml: 0, mt: -.5 }} error>{errors?.compliantCannabisDelivery?.image?.url}</FormHelperText>}
                                </Stack>
                            </div>
                        </Box>
                    </Grid>
                    <Grid container spacing={3} mb={4} className="full-img-sec">
                        <Grid item xs={12} md={4}>
                            <Typography variant="body2" fontWeight="medium" color="#2E2E3A" mb={1}>Section Title(H2)</Typography>
                            <TextField
                                label="Section Title(H2)"
                                className="form-input"
                                fullWidth
                                placeholder="Section Title(H2)"
                                value={formData?.compliantCannabisDelivery?.pageTitle}
                                onChange={(e) => setFormData((prev) => ({ ...prev, compliantCannabisDelivery: { ...prev.compliantCannabisDelivery, pageTitle: e.target.value }, }))}
                                error={Boolean(errors?.compliantCannabisDelivery?.pageTitle)}
                                helperText={errors?.compliantCannabisDelivery?.pageTitle}
                            />
                        </Grid>
                        <Grid item xs={12} md={8}>
                            <Typography variant="body2" fontWeight="medium" color="#2E2E3A" mb={1}>LICENSE(p)</Typography>
                            <TextField
                                label="LICENSE(p)"
                                className="form-input"
                                fullWidth
                                placeholder="LICENSE(p)"
                                value={formData?.compliantCannabisDelivery?.description}
                                onChange={(e) => setFormData((prev) => ({ ...prev, compliantCannabisDelivery: { ...prev.compliantCannabisDelivery, description: e.target.value }, }))}
                                error={Boolean(errors?.compliantCannabisDelivery?.description)}
                                helperText={errors?.compliantCannabisDelivery?.description}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant="body2" fontWeight="medium" color="#2E2E3A" mb={1}>Content</Typography>
                            <CommonQuillEditor
                                allowHeading={false}
                                value={formData?.compliantCannabisDelivery?.content1 || ''}
                                onChange={(value) => setFormData((prev) => ({
                                    ...prev,
                                    compliantCannabisDelivery: { ...prev?.compliantCannabisDelivery, content1: value },
                                }))}
                            />
                            {Boolean(errors?.compliantCannabisDelivery?.content1) && <FormHelperText error>{errors?.compliantCannabisDelivery?.content1}</FormHelperText>}
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant="body2" fontWeight="medium" color="#2E2E3A" mb={1}>Content</Typography>
                            <CommonQuillEditor
                                allowHeading={false}
                                value={formData?.compliantCannabisDelivery?.content2 || ''}
                                onChange={(value) => setFormData((prev) => ({
                                    ...prev,
                                    compliantCannabisDelivery: { ...prev?.compliantCannabisDelivery, content2: value },
                                }))}
                            />
                            {Boolean(errors?.compliantCannabisDelivery?.content2) && <FormHelperText error>{errors?.compliantCannabisDelivery?.content2}</FormHelperText>}
                        </Grid>
                 
                    </Grid>

                    {/* Render All Banners Dynamically */}
                    <div className="no-alernative-sections">
                        {formData?.compliantCannabisDelivery?.section?.map((banner, index) => (
                            <Card sx={{ p: 3, mb: 2, borderRadius: 2.5, boxShadow: 'none' }} key={index}
                                style={{
                                    borderRadius: "18px",
                                    border: "1px solid #F1F1F1"
                                }}
                            >
                                <Box
                                    display="flex"
                                    alignItems="center"
                                    justifyContent="end"
                                    style={{
                                        position: "absolute",
                                        top: "24px",
                                        right: "24px",
                                        width: "24px",
                                        height: "24px"
                                    }}
                                >
                                    <MDButton
                                        sx={{ minWidth: 'auto', p: 0 }}
                                        size="small"
                                        variant='text'
                                        onClick={() => handleDeleteBanner(index, 'compliantCannabisDelivery')}
                                        color="error"
                                    >
                                        <DeleteIcon width="1rem" height="1rem" />
                                    </MDButton>
                                </Box>
                                <div className="st-block-sec">
                                    <div className="st-contents-sec">
                                        <Grid container spacing={3}>

                                            <Grid item xs={12} md={6}>
                                                <Typography variant="body2" fontWeight="medium" color="#2E2E3A" mb={1}>Title (H3)</Typography>
                                                <TextField
                                                    label="Title (H3)"
                                                    className="form-input"
                                                    fullWidth
                                                    placeholder="Title (H3)"
                                                    value={banner.title || ''}
                                                    onChange={(e) => updateBannerField(index, 'title', e.target.value, 'compliantCannabisDelivery')}
                                                    error={Boolean(errors?.compliantCannabisDelivery?.section[index]?.title)}
                                                    helperText={errors?.compliantCannabisDelivery?.section[index]?.title}
                                                />
                                                <span className='drag_drop'>
                                                    Character Count: {banner.title?.length || 0} <span>(Max: 60)</span>
                                                </span>
                                            </Grid>

                                            <Grid item xs={12}>
                                                {/* Description */}
                                                <Typography variant="body2" fontWeight="medium" color="#2E2E3A" mb={1}>Description</Typography>
                                                <CommonQuillEditor
                                                    allowHeading={false}
                                                    value={banner.description || ''}
                                                    onChange={(value) => updateBannerField(index, 'description', value, 'compliantCannabisDelivery')}
                                                />
                                                {Boolean(errors?.compliantCannabisDelivery?.section[index]?.description) && (
                                                    <FormHelperText error>{errors?.compliantCannabisDelivery?.section[index]?.description}</FormHelperText>
                                                )}
                                                <span className='drag_drop'>
                                                    Character Count: {banner.description?.length || 0} <span>(Max: 550)</span>
                                                </span>
                                            </Grid>
                                        </Grid>
                                    </div>
                                </div>
                            </Card>
                        ))}
                    </div>

                    {/* Add More Button */}
                    <Grid item xs={12}>
                        <MDButton type='button' color='primary' size='medium' variant='outlined' sx={{ minWidth: '180px' }} onClick={() => addBanner("compliantCannabisDelivery")}>
                            <Icon>add</Icon>&nbsp;Add More
                        </MDButton>
                    </Grid>

                </AccordionDetails>
            </Accordion>
            {/********************** footer Banner **********************/}
<Accordion expanded={expanded === 'footer'} onChange={handleChange('footer')}>
    <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panelheading-content"
        id="panelheading-footer"
    >
        <Box display="flex" alignItems="center" gap={1}>
            <Typography variant='h4' fontWeight="semibold" style={{ color: "#2E2E3A" }}>Footer Section</Typography>
            <FormControlLabel
                onClick={(e) => e.stopPropagation()}
                control={
                    <Switch
                        checked={formData?.footerSection?.status}
                        onChange={() =>
                            setFormData((prev) => ({ ...prev, footerSection: { ...prev.footerSection, status: !prev.footerSection.status, } }))
                        }
                    />
                }
                label={formData?.footerSection?.status ? "Visible" : "Hidden"}
            />
        </Box>
    </AccordionSummary>
    <AccordionDetails>
        <Grid container direction="row" justifyContent="center" alignItems="center">
            <Grid item xs={12} md={6}>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <Typography variant='body2' fontWeight="medium" color="#2E2E3A" mb={1}>Page Title(H1)</Typography>
                        <TextField
                            label="Page Title(H1)"
                            className="form-input"
                            fullWidth
                            placeholder="Page Title(H1)"
                            value={formData?.footerSection?.pageTitle}
                            onChange={(e) =>
                                setFormData((prev) => ({ ...prev, footerSection: { ...prev.footerSection, pageTitle: e.target.value }, }))
                            }
                            error={Boolean(errors?.footerSection?.pageTitle)}
                            helperText={errors?.footerSection?.pageTitle}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <Typography variant="body2" fontWeight="medium" color="#2E2E3A" mb={1}>Description</Typography>
                        <CommonQuillEditor
                            allowHeading={false}
                            value={formData?.footerSection?.section?.description || ''}
                            onChange={(value) => setFormData((prev) => ({
                                ...prev,
                                footerSection: { ...prev?.footerSection, section: { ...prev?.footerSection?.section, description: value, }, },
                            }))
                            }
                        />
                        {Boolean(errors?.footerSection?.section?.description) && <FormHelperText error>{errors?.footerSection?.section?.description}</FormHelperText>}
                    </Grid>

            

                    <Grid item xs={12}>
                        <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center">
                            <div>
                                <Typography className="w-100" variant="body2" fontWeight="medium" color="#2E2E3A" mb={1}>Top Banner</Typography>
                                <Stack direction='row' alignItems='center' flexWrap='wrap' gap={1.25} className="full-img-sec">
                                    <Badge
                                        overlap='circular'
                                        anchorOrigin={{ vertical: 'top', horizontal: 'right', }}
                                        badgeContent={
                                            isUploading && uploadedImageRef.current === 'footerSection.section.imageUrl' ? <CircularProgress size={32} color='primary' sx={badgeCircularProgressIcon} /> : ''
                                        }
                                    >
                                        {
                                            formData?.footerSection?.section?.image?.url ?
                                                <img style={uploadThumbnailImage} onClick={() => handleModalImage("footerSection", formData?.footerSection?.section?.image)} src={formData?.footerSection?.section?.image?.url || defaultImage} alt='documentId' />
                                                :
                                                <>
                                                    <label htmlFor='footerSectionImage-input' className='add-change-image'>
                                                        <MDButton
                                                            sx={{ minWidth: '180px' }}
                                                            type='button'
                                                            variant='outlined'
                                                            color='secondary'
                                                            component='span'
                                                            disabled={isUploading}
                                                        >
                                                            <div className='add-change-img-sec'>
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                                                    <g clipPath="url(#clip0_13676_49992)">
                                                                        <path d="M14.2274 15.8545C14.1173 15.8547 14.0086 15.8296 13.9089 15.781C13.8093 15.7324 13.7211 15.6615 13.6508 15.5733L12.7504 14.4479V21.8603C12.7504 22.0675 12.6714 22.2662 12.5308 22.4127C12.3901 22.5592 12.1993 22.6416 12.0004 22.6416C11.8015 22.6416 11.6107 22.5592 11.4701 22.4127C11.3294 22.2662 11.2504 22.0675 11.2504 21.8603V14.4479L10.35 15.5733C10.2872 15.6529 10.2099 15.7187 10.1226 15.767C10.0352 15.8153 9.93958 15.8452 9.84113 15.8548C9.74267 15.8645 9.64336 15.8538 9.5489 15.8233C9.45444 15.7928 9.36669 15.7431 9.29072 15.6772C9.21475 15.6113 9.15205 15.5303 9.10623 15.439C9.0604 15.3477 9.03236 15.2479 9.02372 15.1453C9.01508 15.0427 9.026 14.9393 9.05586 14.8411C9.08572 14.7429 9.13393 14.6518 9.19772 14.5731L11.4243 11.7899C11.4947 11.7019 11.5828 11.6311 11.6823 11.5825C11.7819 11.5339 11.8905 11.5088 12.0005 11.5088C12.1104 11.5088 12.219 11.5339 12.3186 11.5825C12.4182 11.6311 12.5063 11.7019 12.5767 11.7899L14.8032 14.5731C14.8945 14.6871 14.9526 14.8259 14.9709 14.9731C14.9891 15.1204 14.9667 15.27 14.9063 15.4044C14.8459 15.5389 14.75 15.6526 14.6297 15.7323C14.5095 15.812 14.37 15.8544 14.2275 15.8545H14.2274ZM22.8011 10.8044C22.1571 9.92076 21.2996 9.23086 20.316 8.80513C20.2817 7.43372 19.8323 6.10864 19.0322 5.01895C18.1059 3.76256 16.7356 2.87852 15.1739 2.52965C11.3639 1.67882 7.26309 4.1002 6.03267 7.9274L5.89955 8.34156C4.32962 8.35074 2.82723 9.00795 1.72172 10.1691C0.616204 11.3303 -0.00223194 12.9007 0.00197444 14.536C0.00618083 16.1714 0.632686 17.7383 1.74416 18.8933C2.85563 20.0483 4.36137 20.6971 5.93133 20.6975H9.36385C9.56276 20.6975 9.75352 20.6152 9.89418 20.4687C10.0348 20.3222 10.1138 20.1235 10.1138 19.9163C10.1138 19.7091 10.0348 19.5104 9.89418 19.3638C9.75352 19.2173 9.56276 19.135 9.36385 19.135H5.93133C4.75618 19.135 3.62916 18.6487 2.7982 17.7832C1.96725 16.9176 1.50042 15.7436 1.50042 14.5195C1.50042 13.2954 1.96725 12.1214 2.7982 11.2558C3.62916 10.3902 4.75618 9.90396 5.93133 9.90396H6.43936C6.5966 9.90396 6.74986 9.85248 6.87748 9.7568C7.0051 9.66112 7.10062 9.52607 7.15055 9.37076L7.45524 8.42349C8.45081 5.32657 11.7724 3.36793 14.8597 4.05748C17.3343 4.61011 18.9586 6.76744 18.8097 9.30381C18.7994 9.47937 18.8462 9.65343 18.9426 9.79781C19.0391 9.9422 19.1794 10.0485 19.341 10.0994C21.2011 10.6849 22.5004 12.5025 22.5004 14.5195C22.4991 15.7432 22.0318 16.9164 21.2012 17.7816C20.3705 18.6469 19.2443 19.1336 18.0695 19.135H14.637C14.4381 19.135 14.2473 19.2173 14.1067 19.3638C13.966 19.5104 13.887 19.7091 13.887 19.9163C13.887 20.1235 13.966 20.3222 14.1067 20.4687C14.2473 20.6152 14.4381 20.6975 14.637 20.6975H18.0695C19.6419 20.6957 21.1495 20.0442 22.2613 18.886C23.3732 17.7278 23.9986 16.1574 24.0004 14.5195C24.003 13.1776 23.5816 11.8721 22.8011 10.8044Z" fill="#2E2E3A" />
                                                                    </g>
                                                                    <defs>
                                                                        <clipPath id="clip0_13676_49992">
                                                                            <rect width="24" height="25" fill="white" />
                                                                        </clipPath>
                                                                    </defs>
                                                                </svg>
                                                                <h5>Add Image</h5>
                                                            </div>

                                                        </MDButton>
                                                    </label></>
                                        }
                                    </Badge>
                                    {formData?.footerSection?.section?.image?.url &&

                                        <label htmlFor='footerSectionImage-input' className='upload-change-image'>
                                            <MDButton
                                                sx={{ minWidth: '180px' }}
                                                type='button'
                                                variant='outlined'
                                                color='secondary'
                                                component='span'
                                                disabled={isUploading}
                                            >
                                                <div className='add-change-img-sec'>
                                                    <p>Change Image</p>
                                                </div>
                                            </MDButton>
                                        </label>
                                    }
                                    <MDInput
                                        id='footerSectionImage-input'
                                        type='file'
                                        name='footerSectionImage'
                                        onChange={(e) => productImageUploadHandler(e, 'footerSection.section.imageUrl')}
                                        fullWidth
                                        disabled={isUploading}
                                        style={{ display: 'none' }}
                                    />
                                    {Boolean(errors?.footerSection?.section?.image?.url) && <FormHelperText sx={{ width: '100%', ml: 0, mt: -.5 }} error>{errors?.footerSection?.section?.image?.url}</FormHelperText>}
                                </Stack>
                            </div>
                        </Box>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant='body2' fontWeight="medium" color="#2E2E3A" mb={1}>CTA Buttons</Typography>
                        {formData?.footerSection?.cta?.map((cta, idx) => (
                            <Card key={idx} sx={{ p: 2, mb: 2, boxShadow: '0 0 1px rgb(0 0 0 / 20%)' }}>
                                <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
                                    <Typography variant='body2' fontWeight="medium" color="#2E2E3A">Button {idx + 1}</Typography>
                                    { (
                                        <MDButton
                                            sx={{ minWidth: 'auto', p: 0 }}
                                            size="small"
                                            variant='text'
                                            onClick={() => handleRemoveHeaderCta(idx,"footerSection")}
                                            style={{ color: "#fd4438" }}
                                        >
                                            <DeleteIcon width="1rem" height="1rem" style={{ color: "#fd4438" }} />
                                        </MDButton>
                                    )}
                                </Box>
                                <Grid container spacing={3}>
                                    <Grid item xs={12} md={6}>
                                        <Typography variant='body2' fontWeight="medium" color="#2E2E3A" mb={1}>Button Name</Typography>
                                        <TextField
                                            label="Button Name"
                                            className="form-input"
                                            fullWidth
                                            placeholder="e.g. Shop Same Day Delivery"
                                            value={cta?.name || ''}
                                            onChange={(e) => handleChangeHeaderCta(e.target.value, 'name', idx, "footerSection")}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <Typography variant='body2' fontWeight="medium" color="#2E2E3A" mb={1}>Button Link</Typography>
                                        <TextField
                                            label="Button Link"
                                            className="form-input"
                                            fullWidth
                                            placeholder="e.g. https://hyperwolf.com/shop"
                                            value={cta?.link || ''}
                                            onChange={(e) => handleChangeHeaderCta(e.target.value, 'link', idx, "footerSection")}
                                        />
                                    </Grid>
                                </Grid>
                            </Card>
                        ))}
                        <MDButton
                            type='button'
                            color='primary'
                            size='medium'
                            variant='outlined'
                            sx={{ minWidth: '180px' }}
                            onClick={()=>handleAddHeaderCta("footerSection")}
                        >
                            <Icon>add</Icon>&nbsp;Add CTA
                        </MDButton>
                    </Grid>

                </Grid>
            </Grid>
        </Grid>
    </AccordionDetails>
</Accordion>
            {/********************** FAQ **********************/}
            <Accordion expanded={expanded === 'faqSection'} onChange={handleChange('faqSection')}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panelfaqSection-content"
                    id="panelfaqSection-header"
                >
                    <Box display="flex" alignItems="center" gap={1}>
                        <Typography variant='h4' fontWeight="semibold" style={{ color: "#2E2E3A" }}>FAQs</Typography>
                        <FormControlLabel
                            onClick={(e) => e.stopPropagation()}
                            control={
                                <Switch
                                    checked={formData?.faq?.status}
                                    onChange={() => setFormData((prev) => ({ ...prev, faq: { ...prev.faq, status: !prev.faq.status, } }))}
                                />
                            }
                            label={formData?.faq?.status ? "Visible" : "Hidden"}
                        />
                    </Box>
                </AccordionSummary>
                <AccordionDetails>
                    {
                        formData?.faq?.section?.length > 0 ? <>
                            {
                                formData?.faq?.section?.map(((faq, idx) => {
                                    return <Grid key={idx} item xs={12} sm={12} lg={12} my={2}>
                                        <Box width={'100%'} className="faq-sec-rep">
                                            <Box display='flex' flexDirection='column' justifyContent='space-between' alignItems={'flex-start'} className="mb-3">
                                                <Box width={'100%'} display="flex" alignItems="center" justifyContent="space-between" mb={1}>
                                                    <Typography variant="body2" fontWeight="medium" color="#2E2E3A">Question</Typography>
                                                    <MDButton
                                                        sx={{ minWidth: 'auto', p: 0 }}
                                                        size="small"
                                                        variant='text'
                                                        onClick={() => handleRemoveFAQ(idx)}
                                                        style={{ color: "#fd4438" }}
                                                    >
                                                        <DeleteIcon width="1rem" height="1rem" style={{ color: "#fd4438" }} />
                                                    </MDButton>
                                                </Box>
                                                <Box width={'100%'}>

                                                    <CommonQuillEditor
                                                        allowHeading={false}
                                                        allowImage={false}
                                                        value={faq?.question || ''}
                                                        onChange={(value) => handleChangeFAQ(value, 'question', idx)}
                                                    />
                                                    {Boolean(errors?.faq?.section[idx]?.question) && (
                                                        <FormHelperText error>{errors?.faq?.section[idx]?.question}</FormHelperText>
                                                    )}
                                                </Box>
                                            </Box>
                                            <Box display='flex' justifyContent='center' alignItems={'flex-start'}>
                                                <Box width={'100%'}>
                                                    <Typography variant="body2" fontWeight="medium" color="#2E2E3A" mb={1}>Answer</Typography>
                                                    <CommonQuillEditor
                                                        allowHeading={false}
                                                        allowImage={false}
                                                        value={faq?.answer || ''}
                                                        onChange={(value) => handleChangeFAQ(value, 'answer', idx)}
                                                    />
                                                    {Boolean(errors?.faq?.section[idx]?.answer) && (
                                                        <FormHelperText error>{errors?.faq?.section[idx]?.answer}</FormHelperText>
                                                    )}
                                                </Box>
                                            </Box>
                                        </Box>
                                    </Grid>;
                                }))
                            }
                        </> : <Grid item xs={12} sm={12} lg={12} mt={3}>
                            <Box display='flex' justifyContent='space-between' alignItems={'center'}>
                                <MDButton
                                    type='button'
                                    color='primary'
                                    size='medium'
                                    variant='outlined'
                                    sx={{ minWidth: '180px' }}
                                    onClick={addFAQHandler}
                                >
                                    <Icon>add</Icon>&nbsp;Add FAQ
                                </MDButton>
                            </Box>
                        </Grid>
                    }

                    {
                        formData?.faq?.section?.length > 0 && <Grid item xs={12} mt={3}>
                            <MDButton
                                type='button'
                                color='primary'
                                size='medium'
                                variant='outlined'
                                sx={{ minWidth: '180px' }}
                                onClick={addFAQHandler}
                            >
                                <Icon>add</Icon>&nbsp;Add More
                            </MDButton>
                        </Grid>
                    }
                </AccordionDetails>
            </Accordion>

            {/********************** Save, Cancel Buttons **********************/}
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} mt={2} mb={2}>
                        <MDButton
                            sx={{ minWidth: '160px' }}
                            type='button'
                            variant='contained'
                            color='primary'
                            onClick={handleSubmit}
                            disabled={isLoading}
                            isLoading={isLoading}
                        >
                            {fullRoleTabSlug ? 'Update' : 'Save'}

                        </MDButton>
                        {
                            notSlug && <MDButton
                                sx={{ minWidth: '160px', backgroundColor: '#fdd5d3', color: '#FD4438' }}
                                type='button'
                                variant='contained'
                                color='error'
                                onClick={() => {
                                    dispatch(openCustomModalDialog({ modalData: { deleteHandler, deleteId: fullRoleTabHeading, deleteType: "page" }, modal: 'DELETE_MODAL' }));
                                }}
                            >
                                Delete
                            </MDButton>
                        }
                        <MDButton
                            sx={{ minWidth: '160px' }}
                            type='button'
                            variant='outlined'
                            color='dark'
                            onClick={() => navigate('/manages/static')}
                        >
                            Cancel
                        </MDButton>
                    </Stack>
                </Grid>
            </Grid>

        </Box>
    )
}

export default SameDayDeliveryPageEdit
